var map = {
	"./CurrencyManagement": 1049,
	"./CurrencyManagement.js": 1049,
	"./TRM": 1050,
	"./TRM.js": 1050,
	"./TRM/filter": 173,
	"./TRM/filter.js": 173,
	"./TRM/table": 174,
	"./TRM/table.js": 174,
	"./accounting/accounts": 1051,
	"./accounting/accounts.js": 1051,
	"./accounting/accounts/filter": 175,
	"./accounting/accounts/filter.js": 175,
	"./accounting/accounts/table": 176,
	"./accounting/accounts/table.js": 176,
	"./accounting/area": 1052,
	"./accounting/area.js": 1052,
	"./accounting/area/filter": 1005,
	"./accounting/area/filter.js": 1005,
	"./accounting/area/table": 177,
	"./accounting/area/table.js": 177,
	"./accounting/area_copy": 1053,
	"./accounting/area_copy.js": 1053,
	"./accounting/closingDayReport": 1054,
	"./accounting/closingDayReport.js": 1054,
	"./accounting/closingDayReport/filter": 178,
	"./accounting/closingDayReport/filter.js": 178,
	"./accounting/closingDayReport/table": 179,
	"./accounting/closingDayReport/table.js": 179,
	"./accounting/concepts": 1055,
	"./accounting/concepts.js": 1055,
	"./accounting/concepts/filter": 180,
	"./accounting/concepts/filter.js": 180,
	"./accounting/concepts/table": 181,
	"./accounting/concepts/table.js": 181,
	"./accounting/costCenter": 1056,
	"./accounting/costCenter.js": 1056,
	"./accounting/costCenter/filter": 182,
	"./accounting/costCenter/filter.js": 182,
	"./accounting/costCenter/table": 183,
	"./accounting/costCenter/table.js": 183,
	"./accounting/employees": 1057,
	"./accounting/employees.js": 1057,
	"./accounting/employees/filter": 1006,
	"./accounting/employees/filter.js": 1006,
	"./accounting/employees/table": 184,
	"./accounting/employees/table.js": 184,
	"./accounting/expenses": 1058,
	"./accounting/expenses.js": 1058,
	"./accounting/expenses/filter": 185,
	"./accounting/expenses/filter.js": 185,
	"./accounting/expenses/table": 186,
	"./accounting/expenses/table.js": 186,
	"./accounting/incomes": 1059,
	"./accounting/incomes.js": 1059,
	"./accounting/incomes/filter": 187,
	"./accounting/incomes/filter.js": 187,
	"./accounting/incomes/table": 188,
	"./accounting/incomes/table.js": 188,
	"./accounting/position": 1060,
	"./accounting/position.js": 1060,
	"./accounting/position/filter": 1007,
	"./accounting/position/filter.js": 1007,
	"./accounting/position/table": 189,
	"./accounting/position/table.js": 189,
	"./accounting/productsThirdBetShop": 1061,
	"./accounting/productsThirdBetShop.js": 1061,
	"./accounting/productsThirdBetShop/filter": 1008,
	"./accounting/productsThirdBetShop/filter.js": 1008,
	"./accounting/productsThirdBetShop/table": 190,
	"./accounting/productsThirdBetShop/table.js": 190,
	"./accounting/productsThirdByBetShop": 1062,
	"./accounting/productsThirdByBetShop.js": 1062,
	"./accounting/productsThirdByBetShop/filter": 191,
	"./accounting/productsThirdByBetShop/filter.js": 191,
	"./accounting/productsThirdByBetShop/table": 192,
	"./accounting/productsThirdByBetShop/table.js": 192,
	"./accounting/productsThirdQuota": 1063,
	"./accounting/productsThirdQuota.js": 1063,
	"./accounting/productsThirdQuota/filter": 193,
	"./accounting/productsThirdQuota/filter.js": 193,
	"./accounting/productsThirdQuota/table": 194,
	"./accounting/productsThirdQuota/table.js": 194,
	"./accounting/providers": 1064,
	"./accounting/providers.js": 1064,
	"./accounting/providers/filter": 1009,
	"./accounting/providers/filter.js": 1009,
	"./accounting/providers/table": 195,
	"./accounting/providers/table.js": 195,
	"./accounting/providers/tableProductsThirdBetShop": 1065,
	"./accounting/providers/tableProductsThirdBetShop.js": 1065,
	"./accounting/providers_copy": 1066,
	"./accounting/providers_copy.js": 1066,
	"./accounting/squareDayReport": 1067,
	"./accounting/squareDayReport.js": 1067,
	"./accounting/squareDayReport/filter": 196,
	"./accounting/squareDayReport/filter.js": 196,
	"./accounting/squareDayReport/table": 197,
	"./accounting/squareDayReport/table.js": 197,
	"./accounting/squareDayReport2": 1068,
	"./accounting/squareDayReport2.js": 1068,
	"./accounting/squareDayReport2/filter": 198,
	"./accounting/squareDayReport2/filter.js": 198,
	"./accounting/squareDayReport2/table": 199,
	"./accounting/squareDayReport2/table.js": 199,
	"./accounting/typeCenterPosition": 1069,
	"./accounting/typeCenterPosition.js": 1069,
	"./accounting/typeDocument": 1070,
	"./accounting/typeDocument.js": 1070,
	"./accounting/typeDocument/filter": 201,
	"./accounting/typeDocument/filter.js": 201,
	"./accounting/typeDocument/table": 202,
	"./accounting/typeDocument/table.js": 202,
	"./accounting/types/filter": 1010,
	"./accounting/types/filter.js": 1010,
	"./accounting/types/table": 200,
	"./accounting/types/table.js": 200,
	"./activateRegistration": 1071,
	"./activateRegistration.js": 1071,
	"./activeProviders": 1072,
	"./activeProviders.js": 1072,
	"./addAdminUserManagement": 1073,
	"./addAdminUserManagement.js": 1073,
	"./addAgentListManagement": 1074,
	"./addAgentListManagement.js": 1074,
	"./addBetShopManagement": 1075,
	"./addBetShopManagement.js": 1075,
	"./adminUser": 1076,
	"./adminUser.js": 1076,
	"./adminUserManagement": 1077,
	"./adminUserManagement.js": 1077,
	"./affiliatesBetShop": 1078,
	"./affiliatesBetShop.js": 1078,
	"./agent/addInformationAgentList": 1079,
	"./agent/addInformationAgentList.js": 1079,
	"./agent/age": 1080,
	"./agent/age.js": 1080,
	"./agent/agent-list/detailsAgentList": 211,
	"./agent/agent-list/detailsAgentList.js": 211,
	"./agent/agent-list/filterAgentList": 212,
	"./agent/agent-list/filterAgentList.js": 212,
	"./agent/agent-list/recordAgentList": 213,
	"./agent/agent-list/recordAgentList.js": 213,
	"./agent/agent-list/recordTableAgentList": 1011,
	"./agent/agent-list/recordTableAgentList.js": 1011,
	"./agent/agent-list/tableAgentList": 214,
	"./agent/agent-list/tableAgentList.js": 214,
	"./agent/agent-retraction/PagoPremio": 215,
	"./agent/agent-retraction/PagoPremio.js": 215,
	"./agent/agent-retraction/search": 216,
	"./agent/agent-retraction/search.js": 216,
	"./agent/agent-retraction/transfers": 217,
	"./agent/agent-retraction/transfers.js": 217,
	"./agent/agent-retraction/transfers1": 218,
	"./agent/agent-retraction/transfers1.js": 218,
	"./agent/agent-transfers/PagoPremio": 219,
	"./agent/agent-transfers/PagoPremio.js": 219,
	"./agent/agent-transfers/search": 220,
	"./agent/agent-transfers/search.js": 220,
	"./agent/agent-transfers/transfers": 221,
	"./agent/agent-transfers/transfers.js": 221,
	"./agent/agent-transfers/transfers1": 222,
	"./agent/agent-transfers/transfers1.js": 222,
	"./agent/agent-tree/details": 1012,
	"./agent/agent-tree/details.js": 1012,
	"./agent/agent-tree/filter": 223,
	"./agent/agent-tree/filter.js": 223,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 224,
	"./agent/agent-tree/recordTableAgentList.js": 224,
	"./agent/agent-tree/table": 225,
	"./agent/agent-tree/table.js": 225,
	"./agent/bonusReportAgentList": 1081,
	"./agent/bonusReportAgentList.js": 1081,
	"./agent/casinoGamesReportAgentList": 1082,
	"./agent/casinoGamesReportAgentList.js": 1082,
	"./agent/comissions": 1083,
	"./agent/comissions.js": 1083,
	"./agent/comissions/autoexclusionUsers": 1084,
	"./agent/comissions/autoexclusionUsers.js": 1084,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1085,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1085,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1086,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1086,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1087,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1087,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1088,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1088,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1089,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1089,
	"./agent/comissions/betsReport/detailsReport": 1090,
	"./agent/comissions/betsReport/detailsReport.js": 1090,
	"./agent/comissions/betsReport/filterReport": 1091,
	"./agent/comissions/betsReport/filterReport.js": 1091,
	"./agent/comissions/betsReport/recordReport": 1092,
	"./agent/comissions/betsReport/recordReport.js": 1092,
	"./agent/comissions/betsReport/recordTableReport": 1093,
	"./agent/comissions/betsReport/recordTableReport.js": 1093,
	"./agent/comissions/betsReport/recordTableTransReport": 1094,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1094,
	"./agent/comissions/betsReport/recordTransReport": 1095,
	"./agent/comissions/betsReport/recordTransReport.js": 1095,
	"./agent/comissions/betsReport/tableReport": 1096,
	"./agent/comissions/betsReport/tableReport.js": 1096,
	"./agent/comissions/betsReportBetShop": 1097,
	"./agent/comissions/betsReportBetShop.js": 1097,
	"./agent/comissions/bonusReport/detailsBonusReport": 1098,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1098,
	"./agent/comissions/bonusReport/filterBonusReport": 1099,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1099,
	"./agent/comissions/bonusReport/recordBonusReport": 1100,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1100,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1101,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1101,
	"./agent/comissions/bonusReport/tableBonusReport": 1102,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1102,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1103,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1103,
	"./agent/comissions/casinoReport/filterCasinoReport": 1104,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1104,
	"./agent/comissions/casinoReport/recordCasinoReport": 1105,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1105,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1106,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1106,
	"./agent/comissions/casinoReport/tableCasinoReport": 1107,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1107,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1108,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1108,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1109,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1109,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1110,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1110,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1111,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1111,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1112,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1112,
	"./agent/comissions/comissions": 1113,
	"./agent/comissions/comissions.js": 1113,
	"./agent/comissions/comissions/table": 234,
	"./agent/comissions/comissions/table.js": 234,
	"./agent/comissions/comissionsReportBetShop": 1114,
	"./agent/comissions/comissionsReportBetShop.js": 1114,
	"./agent/comissions/comissionsReportBetShopDetail": 1115,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1115,
	"./agent/comissions/comissions_report/detailsDepositReports": 1116,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1116,
	"./agent/comissions/comissions_report/filter": 235,
	"./agent/comissions/comissions_report/filter.js": 235,
	"./agent/comissions/comissions_report/recordDepositReports": 1117,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1117,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1118,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1118,
	"./agent/comissions/comissions_report/table": 236,
	"./agent/comissions/comissions_report/table.js": 236,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1119,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1119,
	"./agent/comissions/comissions_report_detail/filter": 237,
	"./agent/comissions/comissions_report_detail/filter.js": 237,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1120,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1120,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1121,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1121,
	"./agent/comissions/comissions_report_detail/table": 238,
	"./agent/comissions/comissions_report_detail/table.js": 238,
	"./agent/comissions/expenses": 1122,
	"./agent/comissions/expenses.js": 1122,
	"./agent/comissions/expenses/filter": 1123,
	"./agent/comissions/expenses/filter.js": 1123,
	"./agent/comissions/expenses/table": 1124,
	"./agent/comissions/expenses/table.js": 1124,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1125,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1125,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1126,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1126,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1127,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1127,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1128,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1128,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1129,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1129,
	"./agent/comissions/incomes": 1130,
	"./agent/comissions/incomes.js": 1130,
	"./agent/comissions/incomes/filter": 1131,
	"./agent/comissions/incomes/filter.js": 1131,
	"./agent/comissions/incomes/table": 1132,
	"./agent/comissions/incomes/table.js": 1132,
	"./agent/comissions/productsThird": 1133,
	"./agent/comissions/productsThird.js": 1133,
	"./agent/comissions/productsThird/filter": 1134,
	"./agent/comissions/productsThird/filter.js": 1134,
	"./agent/comissions/productsThird/table": 1135,
	"./agent/comissions/productsThird/table.js": 1135,
	"./agent/comissions/promotionalCodes": 1136,
	"./agent/comissions/promotionalCodes.js": 1136,
	"./agent/comissions/promotionalCodes/filter": 1137,
	"./agent/comissions/promotionalCodes/filter.js": 1137,
	"./agent/comissions/promotionalCodes/table": 1138,
	"./agent/comissions/promotionalCodes/table.js": 1138,
	"./agent/comissions/withdrawalRequests": 1139,
	"./agent/comissions/withdrawalRequests.js": 1139,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 241,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 241,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 239,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1140,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1140,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 242,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 242,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 240,
	"./agent/configuration/changePassword": 1141,
	"./agent/configuration/changePassword.js": 1141,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1142,
	"./agent/configuration/generateToken.js": 1142,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1143,
	"./agent/configuration/qrgoogle.js": 1143,
	"./agent/configuration/securityChanges": 1144,
	"./agent/configuration/securityChanges.js": 1144,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1145,
	"./agent/configurationAgentList.js": 1145,
	"./agent/depositReportAgentList": 1146,
	"./agent/depositReportAgentList.js": 1146,
	"./agent/financescustomerAgentList": 1147,
	"./agent/financescustomerAgentList.js": 1147,
	"./agent/financial/comisiones": 1148,
	"./agent/financial/comisiones.js": 1148,
	"./agent/financial/comisiones/table": 245,
	"./agent/financial/comisiones/table.js": 245,
	"./agent/financial/informationFinancialAgentList": 1149,
	"./agent/financial/informationFinancialAgentList.js": 1149,
	"./agent/financial/withdrawalRequestsAgentList": 1150,
	"./agent/financial/withdrawalRequestsAgentList.js": 1150,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 246,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 246,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1151,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1151,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 247,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 247,
	"./agent/flujoCajaAgentList": 1152,
	"./agent/flujoCajaAgentList.js": 1152,
	"./agent/flujoCajaHijosAgentList": 1153,
	"./agent/flujoCajaHijosAgentList.js": 1153,
	"./agent/geo": 1154,
	"./agent/geo.js": 1154,
	"./agent/informationAgentList": 1155,
	"./agent/informationAgentList.js": 1155,
	"./agent/informeRed/details": 1156,
	"./agent/informeRed/details.js": 1156,
	"./agent/informeRed/filter": 254,
	"./agent/informeRed/filter.js": 254,
	"./agent/informeRed/record": 1157,
	"./agent/informeRed/record.js": 1157,
	"./agent/informeRed/recordTable": 1158,
	"./agent/informeRed/recordTable.js": 1158,
	"./agent/informeRed/table": 255,
	"./agent/informeRed/table.js": 255,
	"./agent/money": 1159,
	"./agent/money.js": 1159,
	"./agent/paymenthistory": 1160,
	"./agent/paymenthistory.js": 1160,
	"./agent/positions": 1161,
	"./agent/positions.js": 1161,
	"./agent/reports/autoexclusionUsers": 1162,
	"./agent/reports/autoexclusionUsers.js": 1162,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1163,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1163,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1164,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1164,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1165,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1165,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1166,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1166,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1167,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1167,
	"./agent/reports/balanceTransactionReport": 1168,
	"./agent/reports/balanceTransactionReport.js": 1168,
	"./agent/reports/balanceTransactionReport/filter": 256,
	"./agent/reports/balanceTransactionReport/filter.js": 256,
	"./agent/reports/balanceTransactionReport/table": 257,
	"./agent/reports/balanceTransactionReport/table.js": 257,
	"./agent/reports/betsReport/detailsReport": 1169,
	"./agent/reports/betsReport/detailsReport.js": 1169,
	"./agent/reports/betsReport/filterReport": 258,
	"./agent/reports/betsReport/filterReport.js": 258,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1170,
	"./agent/reports/betsReport/recordTableReport.js": 1170,
	"./agent/reports/betsReport/recordTableTransReport": 1171,
	"./agent/reports/betsReport/recordTableTransReport.js": 1171,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 259,
	"./agent/reports/betsReport/tableReport.js": 259,
	"./agent/reports/betsReportAgentList": 1172,
	"./agent/reports/betsReportAgentList.js": 1172,
	"./agent/reports/bonusReport/detailsBonusReport": 228,
	"./agent/reports/bonusReport/detailsBonusReport.js": 228,
	"./agent/reports/bonusReport/filterBonusReport": 226,
	"./agent/reports/bonusReport/filterBonusReport.js": 226,
	"./agent/reports/bonusReport/recordBonusReport": 229,
	"./agent/reports/bonusReport/recordBonusReport.js": 229,
	"./agent/reports/bonusReport/recordTableBonusReport": 1173,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1173,
	"./agent/reports/bonusReport/tableBonusReport": 227,
	"./agent/reports/bonusReport/tableBonusReport.js": 227,
	"./agent/reports/casinoReport/detailsCasinoReport": 232,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 232,
	"./agent/reports/casinoReport/filterCasinoReport": 230,
	"./agent/reports/casinoReport/filterCasinoReport.js": 230,
	"./agent/reports/casinoReport/recordCasinoReport": 233,
	"./agent/reports/casinoReport/recordCasinoReport.js": 233,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1174,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1174,
	"./agent/reports/casinoReport/tableCasinoReport": 231,
	"./agent/reports/casinoReport/tableCasinoReport.js": 231,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1175,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1175,
	"./agent/reports/casinoReport2/filterCasinoReport": 1176,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1176,
	"./agent/reports/casinoReport2/recordCasinoReport": 1177,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1177,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1178,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1178,
	"./agent/reports/casinoReport2/tableCasinoReport": 1179,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1179,
	"./agent/reports/deposit_report/detailsDepositReports": 1180,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1180,
	"./agent/reports/deposit_report/filterDepositReports": 243,
	"./agent/reports/deposit_report/filterDepositReports.js": 243,
	"./agent/reports/deposit_report/recordDepositReports": 1181,
	"./agent/reports/deposit_report/recordDepositReports.js": 1181,
	"./agent/reports/deposit_report/recordTableDepositReports": 1182,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1182,
	"./agent/reports/deposit_report/tableDepositReports": 244,
	"./agent/reports/deposit_report/tableDepositReports.js": 244,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1183,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1183,
	"./agent/reports/flujocaja/filterFlujoCaja": 248,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 248,
	"./agent/reports/flujocaja/recordFlujoCaja": 1184,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1184,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1185,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1185,
	"./agent/reports/flujocaja/tableFlujoCaja": 249,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 249,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 252,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 253,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1186,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1186,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 251,
	"./agent/reports/managementReport": 1187,
	"./agent/reports/managementReport.js": 1187,
	"./agent/reports/managementReport/filterReports": 260,
	"./agent/reports/managementReport/filterReports.js": 260,
	"./agent/reports/managementReport/tableReports": 261,
	"./agent/reports/managementReport/tableReports.js": 261,
	"./agent/reports/marketing/filterReports": 262,
	"./agent/reports/marketing/filterReports.js": 262,
	"./agent/reports/marketing/tableReports": 263,
	"./agent/reports/marketing/tableReports.js": 263,
	"./agent/reports/marketingReport": 1188,
	"./agent/reports/marketingReport.js": 1188,
	"./agent/reports/promotionalCodes": 1189,
	"./agent/reports/promotionalCodes.js": 1189,
	"./agent/reports/promotionalCodes/filter": 264,
	"./agent/reports/promotionalCodes/filter.js": 264,
	"./agent/reports/promotionalCodes/table": 265,
	"./agent/reports/promotionalCodes/table.js": 265,
	"./agent/reports/quotaRetractionReport/filter": 266,
	"./agent/reports/quotaRetractionReport/filter.js": 266,
	"./agent/reports/quotaRetractionReport/table": 267,
	"./agent/reports/quotaRetractionReport/table.js": 267,
	"./agent/reports/quotaRetractionReportAgent": 1190,
	"./agent/reports/quotaRetractionReportAgent.js": 1190,
	"./agent/reports/transfersReport/filter": 268,
	"./agent/reports/transfersReport/filter.js": 268,
	"./agent/reports/transfersReport/table": 269,
	"./agent/reports/transfersReport/table.js": 269,
	"./agent/reports/trasnfersReport": 1191,
	"./agent/reports/trasnfersReport.js": 1191,
	"./agent/reports/userAfilliatesReport": 1192,
	"./agent/reports/userAfilliatesReport.js": 1192,
	"./agent/reports/user_affiliates/detailsReports": 272,
	"./agent/reports/user_affiliates/detailsReports.js": 272,
	"./agent/reports/user_affiliates/filterReports": 270,
	"./agent/reports/user_affiliates/filterReports.js": 270,
	"./agent/reports/user_affiliates/recordReports": 273,
	"./agent/reports/user_affiliates/recordReports.js": 273,
	"./agent/reports/user_affiliates/recordTableReports": 1193,
	"./agent/reports/user_affiliates/recordTableReports.js": 1193,
	"./agent/reports/user_affiliates/tableReports": 271,
	"./agent/reports/user_affiliates/tableReports.js": 271,
	"./agent/reportscustomerAgentList": 1194,
	"./agent/reportscustomerAgentList.js": 1194,
	"./agent/requestsAgent": 1195,
	"./agent/requestsAgent.js": 1195,
	"./agent/requestsAgent/filter": 274,
	"./agent/requestsAgent/filter.js": 274,
	"./agent/requestsAgent/table": 275,
	"./agent/requestsAgent/table.js": 275,
	"./agent/requirementsAgent": 1196,
	"./agent/requirementsAgent.js": 1196,
	"./agent/requirementsAgent/details": 278,
	"./agent/requirementsAgent/details.js": 278,
	"./agent/requirementsAgent/detailsFilter": 280,
	"./agent/requirementsAgent/detailsFilter.js": 280,
	"./agent/requirementsAgent/detailsTable": 279,
	"./agent/requirementsAgent/detailsTable.js": 279,
	"./agent/requirementsAgent/filter": 276,
	"./agent/requirementsAgent/filter.js": 276,
	"./agent/requirementsAgent/table": 277,
	"./agent/requirementsAgent/table.js": 277,
	"./agent/statistics/age": 281,
	"./agent/statistics/age.js": 281,
	"./agent/statistics/marketing": 282,
	"./agent/statistics/marketing.js": 282,
	"./agent/statistics/marketingvsregistros": 283,
	"./agent/statistics/marketingvsregistros.js": 283,
	"./agent/statistics/money": 284,
	"./agent/statistics/money.js": 284,
	"./agent/statisticsAgentList": 1197,
	"./agent/statisticsAgentList.js": 1197,
	"./agent/tags": 1198,
	"./agent/tags.js": 1198,
	"./agentList": 1199,
	"./agentList.js": 1199,
	"./agentListManagement": 1200,
	"./agentListManagement.js": 1200,
	"./agentRetraction": 1201,
	"./agentRetraction.js": 1201,
	"./agentTransfers": 1202,
	"./agentTransfers.js": 1202,
	"./agentsInform": 1203,
	"./agentsInform.js": 1203,
	"./agentsTree": 1204,
	"./agentsTree.js": 1204,
	"./alltactions": 285,
	"./alltactions.js": 285,
	"./approvalLogs": 1205,
	"./approvalLogs.js": 1205,
	"./approvalLogs2": 1206,
	"./approvalLogs2.js": 1206,
	"./approvalLogsBetShop": 1207,
	"./approvalLogsBetShop.js": 1207,
	"./assignmentQuotaMade": 1208,
	"./assignmentQuotaMade.js": 1208,
	"./assignmentQuotaR": 1209,
	"./assignmentQuotaR.js": 1209,
	"./autoexclusionUsers": 1210,
	"./autoexclusionUsers.js": 1210,
	"./balanceAdjustments": 1211,
	"./balanceAdjustments.js": 1211,
	"./balanceHistory": 1212,
	"./balanceHistory.js": 1212,
	"./balanceHistory2": 1213,
	"./balanceHistory2.js": 1213,
	"./balanceHistoryAdminUser": 1214,
	"./balanceHistoryAdminUser.js": 1214,
	"./balanceHistoryBetShop": 1215,
	"./balanceHistoryBetShop.js": 1215,
	"./balanceHistoryBetShop2": 1216,
	"./balanceHistoryBetShop2.js": 1216,
	"./balanceHistoryForAgent": 1217,
	"./balanceHistoryForAgent.js": 1217,
	"./balanceHistoryForBetShop": 1218,
	"./balanceHistoryForBetShop.js": 1218,
	"./balanceHistoryMachine": 1219,
	"./balanceHistoryMachine.js": 1219,
	"./balanceUsers": 1220,
	"./balanceUsers.js": 1220,
	"./bankAccounts": 1221,
	"./bankAccounts.js": 1221,
	"./banks": 1222,
	"./banks.js": 1222,
	"./betShop": 1223,
	"./betShop.js": 1223,
	"./betShopCompetence": 1224,
	"./betShopCompetence.js": 1224,
	"./betShopManagement": 1225,
	"./betShopManagement.js": 1225,
	"./betShopManagement/addInformationBetShop": 1226,
	"./betShopManagement/addInformationBetShop.js": 1226,
	"./betShopManagement/age": 1227,
	"./betShopManagement/age.js": 1227,
	"./betShopManagement/betShop/detailsBetShop": 1013,
	"./betShopManagement/betShop/detailsBetShop.js": 1013,
	"./betShopManagement/betShop/filterBetShop": 326,
	"./betShopManagement/betShop/filterBetShop.js": 326,
	"./betShopManagement/betShop/recordBetShop": 328,
	"./betShopManagement/betShop/recordBetShop.js": 328,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 327,
	"./betShopManagement/betShop/tableBetShop.js": 327,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1228,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1228,
	"./betShopManagement/betShopCompetence/filterBetShop": 329,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 329,
	"./betShopManagement/betShopCompetence/recordBetShop": 1229,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1229,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1230,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1230,
	"./betShopManagement/betShopCompetence/tableBetShop": 330,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 330,
	"./betShopManagement/bonusReportBetShop": 1231,
	"./betShopManagement/bonusReportBetShop.js": 1231,
	"./betShopManagement/cashier/betShopAdvertising": 335,
	"./betShopManagement/cashier/betShopAdvertising.js": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 337,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 337,
	"./betShopManagement/cashier/betShopCashier": 1232,
	"./betShopManagement/cashier/betShopCashier.js": 1232,
	"./betShopManagement/cashier/betShopComissions": 1014,
	"./betShopManagement/cashier/betShopComissions.js": 1014,
	"./betShopManagement/cashier/filterCashier": 340,
	"./betShopManagement/cashier/filterCashier.js": 340,
	"./betShopManagement/cashier/tableAdvertising": 336,
	"./betShopManagement/cashier/tableAdvertising.js": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier": 338,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 338,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 339,
	"./betShopManagement/cashier/tableComissions.js": 339,
	"./betShopManagement/casinoGamesReportBetShop": 1233,
	"./betShopManagement/casinoGamesReportBetShop.js": 1233,
	"./betShopManagement/comissions": 1234,
	"./betShopManagement/comissions.js": 1234,
	"./betShopManagement/comissions/autoexclusionUsers": 1235,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1235,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1238,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1238,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1239,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1239,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1240,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1240,
	"./betShopManagement/comissions/betsReport/detailsReport": 1241,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1241,
	"./betShopManagement/comissions/betsReport/filterReport": 1242,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1242,
	"./betShopManagement/comissions/betsReport/recordReport": 1243,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1243,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1244,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1244,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1245,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1245,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1246,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1246,
	"./betShopManagement/comissions/betsReport/tableReport": 1247,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1247,
	"./betShopManagement/comissions/betsReportBetShop": 1248,
	"./betShopManagement/comissions/betsReportBetShop.js": 1248,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1249,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1249,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1250,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1250,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1251,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1251,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1252,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1252,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1253,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1253,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1254,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1254,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1255,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1255,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1256,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1256,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1257,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1257,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1258,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1258,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1259,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1259,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1260,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1260,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1261,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1261,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1262,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1262,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1263,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1263,
	"./betShopManagement/comissions/comissions": 1264,
	"./betShopManagement/comissions/comissions.js": 1264,
	"./betShopManagement/comissions/comissions/table": 345,
	"./betShopManagement/comissions/comissions/table.js": 345,
	"./betShopManagement/comissions/comissionsReportBetShop": 1265,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1265,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1266,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1266,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1267,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1267,
	"./betShopManagement/comissions/comissions_report/filter": 346,
	"./betShopManagement/comissions/comissions_report/filter.js": 346,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1268,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1268,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1269,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1269,
	"./betShopManagement/comissions/comissions_report/table": 347,
	"./betShopManagement/comissions/comissions_report/table.js": 347,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1270,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1270,
	"./betShopManagement/comissions/comissions_report_detail/filter": 348,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 348,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1271,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1271,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1272,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1272,
	"./betShopManagement/comissions/comissions_report_detail/table": 349,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 349,
	"./betShopManagement/comissions/expenses": 1273,
	"./betShopManagement/comissions/expenses.js": 1273,
	"./betShopManagement/comissions/expenses/filter": 1274,
	"./betShopManagement/comissions/expenses/filter.js": 1274,
	"./betShopManagement/comissions/expenses/table": 1275,
	"./betShopManagement/comissions/expenses/table.js": 1275,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1276,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1276,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1277,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1277,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1278,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1278,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1279,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1279,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1280,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1280,
	"./betShopManagement/comissions/incomes": 1281,
	"./betShopManagement/comissions/incomes.js": 1281,
	"./betShopManagement/comissions/incomes/filter": 1282,
	"./betShopManagement/comissions/incomes/filter.js": 1282,
	"./betShopManagement/comissions/incomes/table": 1283,
	"./betShopManagement/comissions/incomes/table.js": 1283,
	"./betShopManagement/comissions/productsThird": 1284,
	"./betShopManagement/comissions/productsThird.js": 1284,
	"./betShopManagement/comissions/productsThird/filter": 1285,
	"./betShopManagement/comissions/productsThird/filter.js": 1285,
	"./betShopManagement/comissions/productsThird/table": 1286,
	"./betShopManagement/comissions/productsThird/table.js": 1286,
	"./betShopManagement/comissions/promotionalCodes": 1287,
	"./betShopManagement/comissions/promotionalCodes.js": 1287,
	"./betShopManagement/comissions/promotionalCodes/filter": 1288,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1288,
	"./betShopManagement/comissions/promotionalCodes/table": 1289,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1289,
	"./betShopManagement/comissions/withdrawalRequests": 1290,
	"./betShopManagement/comissions/withdrawalRequests.js": 1290,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 352,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 352,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1291,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1291,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 353,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 353,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 351,
	"./betShopManagement/configuration/changePassword": 1292,
	"./betShopManagement/configuration/changePassword.js": 1292,
	"./betShopManagement/configuration/changePassword/changePasswordView": 354,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 354,
	"./betShopManagement/configuration/configNtc": 1293,
	"./betShopManagement/configuration/configNtc.js": 1293,
	"./betShopManagement/configuration/configNtc/configNtcView": 355,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 355,
	"./betShopManagement/configuration/generateToken": 1294,
	"./betShopManagement/configuration/generateToken.js": 1294,
	"./betShopManagement/configuration/generateToken/filter": 356,
	"./betShopManagement/configuration/generateToken/filter.js": 356,
	"./betShopManagement/configuration/generateToken/table": 357,
	"./betShopManagement/configuration/generateToken/table.js": 357,
	"./betShopManagement/configuration/qrgoogle": 1295,
	"./betShopManagement/configuration/qrgoogle.js": 1295,
	"./betShopManagement/configuration/securityChanges": 1296,
	"./betShopManagement/configuration/securityChanges.js": 1296,
	"./betShopManagement/configuration/securityChanges/filter": 1015,
	"./betShopManagement/configuration/securityChanges/filter.js": 1015,
	"./betShopManagement/configuration/securityChanges/table": 358,
	"./betShopManagement/configuration/securityChanges/table.js": 358,
	"./betShopManagement/configurationBetShop": 1297,
	"./betShopManagement/configurationBetShop.js": 1297,
	"./betShopManagement/depositReportBetShop": 1298,
	"./betShopManagement/depositReportBetShop.js": 1298,
	"./betShopManagement/financescustomerBetShop": 1299,
	"./betShopManagement/financescustomerBetShop.js": 1299,
	"./betShopManagement/financial/bankAccountsBetShop": 1300,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1300,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1301,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1301,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 361,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 361,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1302,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1302,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1303,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1303,
	"./betShopManagement/financial/bankAccountsBetShop/table": 362,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 362,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1304,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1304,
	"./betShopManagement/financial/informationFinancialBetShop": 1305,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1305,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1306,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1306,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 364,
	"./betShopManagement/flujoCajaBetShop": 1307,
	"./betShopManagement/flujoCajaBetShop.js": 1307,
	"./betShopManagement/geo": 1308,
	"./betShopManagement/geo.js": 1308,
	"./betShopManagement/informationBetShop": 1309,
	"./betShopManagement/informationBetShop.js": 1309,
	"./betShopManagement/money": 1310,
	"./betShopManagement/money.js": 1310,
	"./betShopManagement/paymenthistory": 1311,
	"./betShopManagement/paymenthistory.js": 1311,
	"./betShopManagement/positions": 1312,
	"./betShopManagement/positions.js": 1312,
	"./betShopManagement/reports/autoexclusionUsers": 1313,
	"./betShopManagement/reports/autoexclusionUsers.js": 1313,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1314,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1314,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1315,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1315,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1316,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1316,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1317,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1317,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1318,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1318,
	"./betShopManagement/reports/balanceTransactionReport": 1319,
	"./betShopManagement/reports/balanceTransactionReport.js": 1319,
	"./betShopManagement/reports/balanceTransactionReport/filter": 368,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 368,
	"./betShopManagement/reports/balanceTransactionReport/table": 369,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 369,
	"./betShopManagement/reports/betsReport/detailsReport": 1320,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1320,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1321,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1321,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1322,
	"./betShopManagement/reports/betsReportBetShop.js": 1322,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 333,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 333,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 334,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 334,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1323,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1323,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 332,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 332,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1324,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1324,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1325,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1325,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1326,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1326,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1327,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1327,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1328,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1328,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1329,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1329,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1016,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1016,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 359,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 359,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1330,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1330,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 360,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 360,
	"./betShopManagement/reports/expenses": 1331,
	"./betShopManagement/reports/expenses.js": 1331,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1332,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1332,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 366,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 366,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1333,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1333,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1334,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1334,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 367,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 367,
	"./betShopManagement/reports/historyMovement": 1335,
	"./betShopManagement/reports/historyMovement.js": 1335,
	"./betShopManagement/reports/historyMovement/filter": 370,
	"./betShopManagement/reports/historyMovement/filter.js": 370,
	"./betShopManagement/reports/historyMovement/table": 371,
	"./betShopManagement/reports/historyMovement/table.js": 371,
	"./betShopManagement/reports/incomes": 1336,
	"./betShopManagement/reports/incomes.js": 1336,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1337,
	"./betShopManagement/reports/productsThird.js": 1337,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1338,
	"./betShopManagement/reports/promotionalCodes.js": 1338,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1339,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1339,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 373,
	"./betShopManagement/reportscustomerBetShop": 1340,
	"./betShopManagement/reportscustomerBetShop.js": 1340,
	"./betShopManagement/statisticsBetShop": 1341,
	"./betShopManagement/statisticsBetShop.js": 1341,
	"./betShopManagement/tags": 1342,
	"./betShopManagement/tags.js": 1342,
	"./betsHistory": 1343,
	"./betsHistory.js": 1343,
	"./betsHistory2": 1344,
	"./betsHistory2.js": 1344,
	"./betsReport": 1345,
	"./betsReport.js": 1345,
	"./betsReportBetShop": 1346,
	"./betsReportBetShop.js": 1346,
	"./betsReportSecond": 1347,
	"./betsReportSecond.js": 1347,
	"./betsSport": 1348,
	"./betsSport.js": 1348,
	"./betsSportLive": 1349,
	"./betsSportLive.js": 1349,
	"./betsVirtual": 1350,
	"./betsVirtual.js": 1350,
	"./betting": 1351,
	"./betting.js": 1351,
	"./bettingVirtual": 1352,
	"./bettingVirtual.js": 1352,
	"./blockchains": 1353,
	"./blockchains.js": 1353,
	"./bonusReport": 1354,
	"./bonusReport.js": 1354,
	"./bonusReport2": 1355,
	"./bonusReport2.js": 1355,
	"./bonusReports2": 1356,
	"./bonusReports2.js": 1356,
	"./cash/bankAccounts/filter": 321,
	"./cash/bankAccounts/filter.js": 321,
	"./cash/bankAccounts/table": 322,
	"./cash/bankAccounts/table.js": 322,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1357,
	"./cash/bets/betHistory2.js": 1357,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 378,
	"./cash/bets/sportLive.js": 378,
	"./cash/bets/sportVirtual": 379,
	"./cash/bets/sportVirtual.js": 379,
	"./cash/closeBox-edit/creditCards": 388,
	"./cash/closeBox-edit/creditCards.js": 388,
	"./cash/closeBox-edit/otherExpenses": 389,
	"./cash/closeBox-edit/otherExpenses.js": 389,
	"./cash/closeBox-edit/otherIncome": 390,
	"./cash/closeBox-edit/otherIncome.js": 390,
	"./cash/closeBox-edit/products": 391,
	"./cash/closeBox-edit/products.js": 391,
	"./cash/closeBox-edit/total": 392,
	"./cash/closeBox-edit/total.js": 392,
	"./cash/closeBox-old/otherExpenses": 1358,
	"./cash/closeBox-old/otherExpenses.js": 1358,
	"./cash/closeBox-old/otherIncome": 1359,
	"./cash/closeBox-old/otherIncome.js": 1359,
	"./cash/closeBox-old/products": 1360,
	"./cash/closeBox-old/products.js": 1360,
	"./cash/closeBox-old/total": 1361,
	"./cash/closeBox-old/total.js": 1361,
	"./cash/closeBox/creditCards": 393,
	"./cash/closeBox/creditCards.js": 393,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 394,
	"./cash/flujocaja/detailsFlujoCaja.js": 394,
	"./cash/flujocaja/filterFlujoCaja": 395,
	"./cash/flujocaja/filterFlujoCaja.js": 395,
	"./cash/flujocaja/recordFlujoCaja": 396,
	"./cash/flujocaja/recordFlujoCaja.js": 396,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 397,
	"./cash/flujocaja/tableFlujoCaja.js": 397,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 398,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 398,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 399,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 399,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1017,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1017,
	"./cash/pagopremio/PagoPremio": 400,
	"./cash/pagopremio/PagoPremio.js": 400,
	"./cash/pagopremio/detailsPagoPremio": 401,
	"./cash/pagopremio/detailsPagoPremio.js": 401,
	"./cash/pagopremio/filterPagoPremio": 402,
	"./cash/pagopremio/filterPagoPremio.js": 402,
	"./cash/pagopremio/recordPagoPremio": 403,
	"./cash/pagopremio/recordPagoPremio.js": 403,
	"./cash/pagopremio/recordTablePagoPremio": 1362,
	"./cash/pagopremio/recordTablePagoPremio.js": 1362,
	"./cash/pagopremio/tablePagoPremio": 404,
	"./cash/pagopremio/tablePagoPremio.js": 404,
	"./cash/pagopremiovirtuales/PagoPremio": 405,
	"./cash/pagopremiovirtuales/PagoPremio.js": 405,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 406,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 406,
	"./cash/pagopremiovirtuales/filterPagoPremio": 407,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 407,
	"./cash/pagopremiovirtuales/recordPagoPremio": 408,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 408,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1363,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1363,
	"./cash/pagopremiovirtuales/tablePagoPremio": 409,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 409,
	"./cash/payPrizesLoyalty/PagoPremio": 410,
	"./cash/payPrizesLoyalty/PagoPremio.js": 410,
	"./cash/payPrizesLoyalty/filterPagoPremio": 411,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 411,
	"./cash/recargacredito/RecargaCredito": 412,
	"./cash/recargacredito/RecargaCredito.js": 412,
	"./cash/recargacredito/filterRecargaCredito": 413,
	"./cash/recargacredito/filterRecargaCredito.js": 413,
	"./cash/recargacreditoAgent/RecargaCredito": 414,
	"./cash/recargacreditoAgent/RecargaCredito.js": 414,
	"./cash/recargacreditoAgent/filterRecargaCredito": 415,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 415,
	"./cash/withdrawal/filter": 416,
	"./cash/withdrawal/filter.js": 416,
	"./cash/withdrawal/table": 417,
	"./cash/withdrawal/table.js": 417,
	"./cashiers": 1364,
	"./cashiers.js": 1364,
	"./casinoGamesReport": 1365,
	"./casinoGamesReport.js": 1365,
	"./casinoGamesReport2": 1367,
	"./casinoGamesReport2.js": 1367,
	"./categories": 1368,
	"./categories.js": 1368,
	"./categoriesProducts": 1369,
	"./categoriesProducts.js": 1369,
	"./closeBox": 1370,
	"./closeBox-old": 1371,
	"./closeBox-old.js": 1371,
	"./closeBox.js": 1370,
	"./closeBoxEdit": 1372,
	"./closeBoxEdit.js": 1372,
	"./comissionsReport": 1373,
	"./comissionsReport.js": 1373,
	"./comissionsReport2": 1374,
	"./comissionsReport2.js": 1374,
	"./commisionsPay": 1375,
	"./commisionsPay.js": 1375,
	"./competitors/competitors": 1376,
	"./competitors/competitors.js": 1376,
	"./competitors/filter": 434,
	"./competitors/filter.js": 434,
	"./competitors/table": 435,
	"./competitors/table.js": 435,
	"./consolidatedIncome": 1377,
	"./consolidatedIncome.js": 1377,
	"./consolidatedIncomeOwner": 1378,
	"./consolidatedIncomeOwner.js": 1378,
	"./consolidatedIncomeOwner2": 1379,
	"./consolidatedIncomeOwner2.js": 1379,
	"./contingency": 1380,
	"./contingency.js": 1380,
	"./countries": 1381,
	"./countries.js": 1381,
	"./coupons": 1382,
	"./coupons.js": 1382,
	"./couponsReport": 1383,
	"./couponsReport.js": 1383,
	"./cryptoBlockchain": 1384,
	"./cryptoBlockchain.js": 1384,
	"./cryptos": 1385,
	"./cryptos.js": 1385,
	"./customReport": 1386,
	"./customReport.js": 1386,
	"./customers": 1387,
	"./customers.js": 1387,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1388,
	"./customers/bonusReport.js": 1388,
	"./customers/bonusReport2": 1389,
	"./customers/bonusReport2.js": 1389,
	"./customers/casinoGamesReport": 1390,
	"./customers/casinoGamesReport.js": 1390,
	"./customers/configuration": 1391,
	"./customers/configuration.js": 1391,
	"./customers/configuration/changePassword": 1392,
	"./customers/configuration/changePassword.js": 1392,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1393,
	"./customers/configuration/generateToken.js": 1393,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1394,
	"./customers/configuration/limitChanges.js": 1394,
	"./customers/configuration/securityChanges": 1395,
	"./customers/configuration/securityChanges.js": 1395,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1396,
	"./customers/configuration/securityChanges2.js": 1396,
	"./customers/depositReport": 1397,
	"./customers/depositReport.js": 1397,
	"./customers/financescustomer": 1398,
	"./customers/financescustomer.js": 1398,
	"./customers/financial/bankAccounts": 1399,
	"./customers/financial/bankAccounts.js": 1399,
	"./customers/financial/bankAccounts/details": 1022,
	"./customers/financial/bankAccounts/details.js": 1022,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 457,
	"./customers/financial/bankAccounts/record.js": 457,
	"./customers/financial/bankAccounts/recordTable": 1400,
	"./customers/financial/bankAccounts/recordTable.js": 1400,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1401,
	"./customers/financial/bankAccounts/tablePopup.js": 1401,
	"./customers/financial/informationFinancial": 1402,
	"./customers/financial/informationFinancial.js": 1402,
	"./customers/financial/withdrawalRequests": 1403,
	"./customers/financial/withdrawalRequests.js": 1403,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1404,
	"./customers/information.js": 1404,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 458,
	"./customers/paymenthistory.js": 458,
	"./customers/players/filter": 459,
	"./customers/players/filter.js": 459,
	"./customers/players/table": 460,
	"./customers/players/table.js": 460,
	"./customers/players2/filter": 461,
	"./customers/players2/filter.js": 461,
	"./customers/players2/table": 462,
	"./customers/players2/table.js": 462,
	"./customers/playersAggregator/filter": 463,
	"./customers/playersAggregator/filter.js": 463,
	"./customers/playersAggregator/table": 464,
	"./customers/playersAggregator/table.js": 464,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1405,
	"./customers/referralsReport.js": 1405,
	"./customers/reports/autoexclusionUsers": 1406,
	"./customers/reports/autoexclusionUsers.js": 1406,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1407,
	"./customers/reports/balanceAdjustments.js": 1407,
	"./customers/reports/balanceAdjustments/filter": 467,
	"./customers/reports/balanceAdjustments/filter.js": 467,
	"./customers/reports/balanceAdjustments/table": 468,
	"./customers/reports/balanceAdjustments/table.js": 468,
	"./customers/reports/balanceHistory": 1408,
	"./customers/reports/balanceHistory.js": 1408,
	"./customers/reports/balanceHistory/filter": 469,
	"./customers/reports/balanceHistory/filter.js": 469,
	"./customers/reports/balanceHistory/table": 470,
	"./customers/reports/balanceHistory/table.js": 470,
	"./customers/reports/betsReport": 1409,
	"./customers/reports/betsReport.js": 1409,
	"./customers/reports/betsReport/detailsReport": 1410,
	"./customers/reports/betsReport/detailsReport.js": 1410,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 455,
	"./customers/reports/bonusReport2/filterBonusReport.js": 455,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1411,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1411,
	"./customers/reports/bonusReport2/tableBonusReport": 456,
	"./customers/reports/bonusReport2/tableBonusReport.js": 456,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1412,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1412,
	"./customers/reports/casinoReport2/filterCasinoReport": 1413,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1413,
	"./customers/reports/casinoReport2/recordCasinoReport": 1414,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1414,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1415,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1415,
	"./customers/reports/casinoReport2/tableCasinoReport": 1416,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1416,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1417,
	"./customers/reports/historyMovement.js": 1417,
	"./customers/reports/historyMovement/filter": 471,
	"./customers/reports/historyMovement/filter.js": 471,
	"./customers/reports/historyMovement/table": 472,
	"./customers/reports/historyMovement/table.js": 472,
	"./customers/reports/historyPoints": 1418,
	"./customers/reports/historyPoints.js": 1418,
	"./customers/reports/historyPoints/filter": 473,
	"./customers/reports/historyPoints/filter.js": 473,
	"./customers/reports/historyPoints/table": 474,
	"./customers/reports/historyPoints/table.js": 474,
	"./customers/reports/logsUser": 1419,
	"./customers/reports/logsUser.js": 1419,
	"./customers/reports/logsUser/filter": 475,
	"./customers/reports/logsUser/filter.js": 475,
	"./customers/reports/logsUser/table": 476,
	"./customers/reports/logsUser/table.js": 476,
	"./customers/reports/loyaltyLevelChangeHistory": 1023,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1023,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 477,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 477,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 478,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 478,
	"./customers/reports/notesUser": 1420,
	"./customers/reports/notesUser.js": 1420,
	"./customers/reports/notesUser/filter": 479,
	"./customers/reports/notesUser/filter.js": 479,
	"./customers/reports/notesUser/table": 480,
	"./customers/reports/notesUser/table.js": 480,
	"./customers/reports/playerPrizesLoyalty": 1421,
	"./customers/reports/playerPrizesLoyalty.js": 1421,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 481,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 481,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 482,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 482,
	"./customers/reports/playerRoulette": 1422,
	"./customers/reports/playerRoulette.js": 1422,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 483,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 483,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 484,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 484,
	"./customers/reports/qualifyingPointsRecord": 1423,
	"./customers/reports/qualifyingPointsRecord.js": 1423,
	"./customers/reports/qualifyingPointsRecordReport/filter": 485,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 485,
	"./customers/reports/qualifyingPointsRecordReport/table": 486,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 486,
	"./customers/reports/referralsReport/filterReferralsReports": 465,
	"./customers/reports/referralsReport/filterReferralsReports.js": 465,
	"./customers/reports/referralsReport/recordReferralsReports": 1424,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1424,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1425,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1425,
	"./customers/reports/referralsReport/tableReferralsReports": 466,
	"./customers/reports/referralsReport/tableReferralsReports.js": 466,
	"./customers/reports/registeredDocument": 1426,
	"./customers/reports/registeredDocument.js": 1426,
	"./customers/reports/registeredDocuments/filter": 487,
	"./customers/reports/registeredDocuments/filter.js": 487,
	"./customers/reports/registeredDocuments/table": 488,
	"./customers/reports/registeredDocuments/table.js": 488,
	"./customers/reports/sessionsReport": 1427,
	"./customers/reports/sessionsReport.js": 1427,
	"./customers/reports/sessionsReport/detailsSessionsReport": 491,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 491,
	"./customers/reports/sessionsReport/filterSessionsReport": 489,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 489,
	"./customers/reports/sessionsReport/recordSessionsReport": 1024,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1024,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1025,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1025,
	"./customers/reports/sessionsReport/tableSessionsReport": 490,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 490,
	"./customers/reports/sessionsReport2": 1428,
	"./customers/reports/sessionsReport2.js": 1428,
	"./customers/reports/sessionsReport2/filter": 492,
	"./customers/reports/sessionsReport2/filter.js": 492,
	"./customers/reports/sessionsReport2/table": 493,
	"./customers/reports/sessionsReport2/table.js": 493,
	"./customers/reports/walletsReport": 1429,
	"./customers/reports/walletsReport.js": 1429,
	"./customers/reports/walletsReport/filter": 494,
	"./customers/reports/walletsReport/filter.js": 494,
	"./customers/reports/walletsReport/table": 495,
	"./customers/reports/walletsReport/table.js": 495,
	"./customers/reportscustomer": 1430,
	"./customers/reportscustomer.js": 1430,
	"./customers/statistics": 1431,
	"./customers/statistics.js": 1431,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1432,
	"./customersAggregator.js": 1432,
	"./customersAggregator/age": 1433,
	"./customersAggregator/age.js": 1433,
	"./customersAggregator/bonusReport": 1434,
	"./customersAggregator/bonusReport.js": 1434,
	"./customersAggregator/casinoGamesReport": 1435,
	"./customersAggregator/casinoGamesReport.js": 1435,
	"./customersAggregator/configuration": 1436,
	"./customersAggregator/configuration.js": 1436,
	"./customersAggregator/configuration/changePassword": 1437,
	"./customersAggregator/configuration/changePassword.js": 1437,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1438,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1438,
	"./customersAggregator/configuration/generateToken": 1439,
	"./customersAggregator/configuration/generateToken.js": 1439,
	"./customersAggregator/configuration/generateToken/filter": 1440,
	"./customersAggregator/configuration/generateToken/filter.js": 1440,
	"./customersAggregator/configuration/generateToken/table": 1441,
	"./customersAggregator/configuration/generateToken/table.js": 1441,
	"./customersAggregator/configuration/securityChanges": 1442,
	"./customersAggregator/configuration/securityChanges.js": 1442,
	"./customersAggregator/configuration/securityChanges/filter": 1443,
	"./customersAggregator/configuration/securityChanges/filter.js": 1443,
	"./customersAggregator/configuration/securityChanges/table": 1444,
	"./customersAggregator/configuration/securityChanges/table.js": 1444,
	"./customersAggregator/depositReport": 1445,
	"./customersAggregator/depositReport.js": 1445,
	"./customersAggregator/financescustomer": 1446,
	"./customersAggregator/financescustomer.js": 1446,
	"./customersAggregator/financial/bankAccounts": 1447,
	"./customersAggregator/financial/bankAccounts.js": 1447,
	"./customersAggregator/financial/bankAccounts/details": 1448,
	"./customersAggregator/financial/bankAccounts/details.js": 1448,
	"./customersAggregator/financial/bankAccounts/filter": 1449,
	"./customersAggregator/financial/bankAccounts/filter.js": 1449,
	"./customersAggregator/financial/bankAccounts/record": 1450,
	"./customersAggregator/financial/bankAccounts/record.js": 1450,
	"./customersAggregator/financial/bankAccounts/recordTable": 1451,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1451,
	"./customersAggregator/financial/bankAccounts/table": 1452,
	"./customersAggregator/financial/bankAccounts/table.js": 1452,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1453,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1453,
	"./customersAggregator/financial/informationFinancial": 1454,
	"./customersAggregator/financial/informationFinancial.js": 1454,
	"./customersAggregator/financial/withdrawalRequests": 1455,
	"./customersAggregator/financial/withdrawalRequests.js": 1455,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1456,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1456,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1457,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1457,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1458,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1458,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1459,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1459,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1460,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1460,
	"./customersAggregator/geo": 1461,
	"./customersAggregator/geo.js": 1461,
	"./customersAggregator/information": 1462,
	"./customersAggregator/information.js": 1462,
	"./customersAggregator/money": 1463,
	"./customersAggregator/money.js": 1463,
	"./customersAggregator/paymenthistory": 1464,
	"./customersAggregator/paymenthistory.js": 1464,
	"./customersAggregator/players/filter": 1465,
	"./customersAggregator/players/filter.js": 1465,
	"./customersAggregator/players/table": 1466,
	"./customersAggregator/players/table.js": 1466,
	"./customersAggregator/playersAggregator/filter": 1467,
	"./customersAggregator/playersAggregator/filter.js": 1467,
	"./customersAggregator/playersAggregator/table": 1468,
	"./customersAggregator/playersAggregator/table.js": 1468,
	"./customersAggregator/positions": 1469,
	"./customersAggregator/positions.js": 1469,
	"./customersAggregator/reports/autoexclusionUsers": 1470,
	"./customersAggregator/reports/autoexclusionUsers.js": 1470,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1471,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1471,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1472,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1472,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1473,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1473,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1474,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1474,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1475,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1475,
	"./customersAggregator/reports/betsReport": 1476,
	"./customersAggregator/reports/betsReport.js": 1476,
	"./customersAggregator/reports/betsReport/detailsReport": 1477,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1477,
	"./customersAggregator/reports/betsReport/filterReport": 1478,
	"./customersAggregator/reports/betsReport/filterReport.js": 1478,
	"./customersAggregator/reports/betsReport/recordReport": 1479,
	"./customersAggregator/reports/betsReport/recordReport.js": 1479,
	"./customersAggregator/reports/betsReport/recordTableReport": 1480,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1480,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1481,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1481,
	"./customersAggregator/reports/betsReport/recordTransReport": 1482,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1482,
	"./customersAggregator/reports/betsReport/tableReport": 1483,
	"./customersAggregator/reports/betsReport/tableReport.js": 1483,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1484,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1484,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1485,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1485,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1486,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1486,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1487,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1487,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1488,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1488,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1489,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1489,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1490,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1490,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1491,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1491,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1492,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1492,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1493,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1493,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1494,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1494,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1495,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1495,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1496,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1496,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1497,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1497,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1498,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1498,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1499,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1499,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1500,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1500,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1501,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1501,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1502,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1502,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1503,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1503,
	"./customersAggregator/reportscustomer": 1504,
	"./customersAggregator/reportscustomer.js": 1504,
	"./customersAggregator/statistics": 1505,
	"./customersAggregator/statistics.js": 1505,
	"./customersAggregator/tags": 1506,
	"./customersAggregator/tags.js": 1506,
	"./dashboard": 1507,
	"./dashboard.js": 1507,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 496,
	"./dates.js": 496,
	"./demos": 1508,
	"./demos.js": 1508,
	"./depositReport": 1509,
	"./depositReport.js": 1509,
	"./depositReport2": 1510,
	"./depositReport2.js": 1510,
	"./depositReport3": 1511,
	"./depositReport3.js": 1511,
	"./depositReportBetShop": 1512,
	"./depositReportBetShop.js": 1512,
	"./depositReportFranchise": 1513,
	"./depositReportFranchise.js": 1513,
	"./depositRequests": 1514,
	"./depositRequests.js": 1514,
	"./eliminateNoteWithdraw": 1515,
	"./eliminateNoteWithdraw.js": 1515,
	"./emailsReport": 1516,
	"./emailsReport.js": 1516,
	"./financial/depositRequests/filter": 507,
	"./financial/depositRequests/filter.js": 507,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 509,
	"./financial/depositRequests/recordTable.js": 509,
	"./financial/depositRequests/table": 508,
	"./financial/depositRequests/table.js": 508,
	"./financial/withdrawalRequests": 1517,
	"./financial/withdrawalRequests.js": 1517,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 516,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 516,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1518,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1518,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 517,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 517,
	"./flujoCaja": 1519,
	"./flujoCaja.js": 1519,
	"./franchisee": 1520,
	"./franchisee.js": 1520,
	"./franchises": 1521,
	"./franchises.js": 1521,
	"./futureEvents": 1522,
	"./futureEvents.js": 1522,
	"./gamePerformanceReport": 1523,
	"./gamePerformanceReport.js": 1523,
	"./getReportStructureGames": 1524,
	"./getReportStructureGames.js": 1524,
	"./goldenRace": 1525,
	"./goldenRace.js": 1525,
	"./historicalCashFlow": 1526,
	"./historicalCashFlow.js": 1526,
	"./historyMovement": 1527,
	"./historyMovement.js": 1527,
	"./historyMovement/filter": 1528,
	"./historyMovement/filter.js": 1528,
	"./historyMovement/table": 1529,
	"./historyMovement/table.js": 1529,
	"./historyMovementBetShop": 1530,
	"./historyMovementBetShop.js": 1530,
	"./historyPoints": 1531,
	"./historyPoints.js": 1531,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1532,
	"./information/recordTable.js": 1532,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1533,
	"./informationCasino.js": 1533,
	"./informationHipica": 1534,
	"./informationHipica.js": 1534,
	"./informationLiveCasino": 1535,
	"./informationLiveCasino.js": 1535,
	"./informationVirtual": 1536,
	"./informationVirtual.js": 1536,
	"./informeCasino": 1537,
	"./informeCasino.js": 1537,
	"./informeGerencial": 1538,
	"./informeGerencial.js": 1538,
	"./informeGerencial2": 1539,
	"./informeGerencial2.js": 1539,
	"./informeGerencialAgentes2": 1540,
	"./informeGerencialAgentes2.js": 1540,
	"./informeGerencialUsuarios2": 1541,
	"./informeGerencialUsuarios2.js": 1541,
	"./jackpotInternationalReport2": 1542,
	"./jackpotInternationalReport2.js": 1542,
	"./jackpotPaymentReports": 1543,
	"./jackpotPaymentReports.js": 1543,
	"./jackpotPaymentReports2": 1544,
	"./jackpotPaymentReports2.js": 1544,
	"./jackpotPrizeReport": 1545,
	"./jackpotPrizeReport.js": 1545,
	"./jackpotPrizeReportSportBet": 1546,
	"./jackpotPrizeReportSportBet.js": 1546,
	"./jackpotWinnersReport": 1547,
	"./jackpotWinnersReport.js": 1547,
	"./landingReport": 1548,
	"./landingReport.js": 1548,
	"./landingReport2": 1549,
	"./landingReport2.js": 1549,
	"./leagues/AddLeague": 1550,
	"./leagues/AddLeague.js": 1550,
	"./leagues/addLeagueManagement": 1551,
	"./leagues/addLeagueManagement.js": 1551,
	"./leagues/configuration": 1552,
	"./leagues/configuration.js": 1552,
	"./leagues/configuration/changePassword": 1553,
	"./leagues/configuration/changePassword.js": 1553,
	"./leagues/configuration/changePassword/changePasswordView": 1554,
	"./leagues/configuration/changePassword/changePasswordView.js": 1554,
	"./leagues/configuration/generateToken": 1555,
	"./leagues/configuration/generateToken.js": 1555,
	"./leagues/configuration/generateToken/filter": 1556,
	"./leagues/configuration/generateToken/filter.js": 1556,
	"./leagues/configuration/generateToken/table": 1557,
	"./leagues/configuration/generateToken/table.js": 1557,
	"./leagues/configuration/qrgoogle": 1558,
	"./leagues/configuration/qrgoogle.js": 1558,
	"./leagues/configuration/securityChanges": 1559,
	"./leagues/configuration/securityChanges.js": 1559,
	"./leagues/configuration/securityChanges/filter": 1560,
	"./leagues/configuration/securityChanges/filter.js": 1560,
	"./leagues/configuration/securityChanges/table": 1561,
	"./leagues/configuration/securityChanges/table.js": 1561,
	"./leagues/information": 1562,
	"./leagues/information.js": 1562,
	"./leagues/leagues-list/filter": 569,
	"./leagues/leagues-list/filter.js": 569,
	"./leagues/leagues-list/table": 570,
	"./leagues/leagues-list/table.js": 570,
	"./leagues/leaguesList": 1563,
	"./leagues/leaguesList.js": 1563,
	"./leagues/leaguesManagement": 1564,
	"./leagues/leaguesManagement.js": 1564,
	"./leagues/reports": 1565,
	"./leagues/reports.js": 1565,
	"./leagues/reports/betsReport": 1566,
	"./leagues/reports/betsReport.js": 1566,
	"./leagues/reports/betsReport/detailsReport": 1567,
	"./leagues/reports/betsReport/detailsReport.js": 1567,
	"./leagues/reports/betsReport/filterReport": 572,
	"./leagues/reports/betsReport/filterReport.js": 572,
	"./leagues/reports/betsReport/recordReport": 1568,
	"./leagues/reports/betsReport/recordReport.js": 1568,
	"./leagues/reports/betsReport/recordTableReport": 1569,
	"./leagues/reports/betsReport/recordTableReport.js": 1569,
	"./leagues/reports/betsReport/recordTableTransReport": 1570,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1570,
	"./leagues/reports/betsReport/recordTransReport": 574,
	"./leagues/reports/betsReport/recordTransReport.js": 574,
	"./leagues/reports/betsReport/tableReport": 573,
	"./leagues/reports/betsReport/tableReport.js": 573,
	"./leagues/reports/casinoGamesReport": 1571,
	"./leagues/reports/casinoGamesReport.js": 1571,
	"./leagues/reports/casinoReport/detailsCasinoReport": 577,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 577,
	"./leagues/reports/casinoReport/filterCasinoReport": 575,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 575,
	"./leagues/reports/casinoReport/recordCasinoReport": 578,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 578,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1572,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1572,
	"./leagues/reports/casinoReport/tableCasinoReport": 576,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 576,
	"./leagues/reports/userAfilliatesReport": 1573,
	"./leagues/reports/userAfilliatesReport.js": 1573,
	"./leagues/reports/user_affiliates/detailsReports": 1574,
	"./leagues/reports/user_affiliates/detailsReports.js": 1574,
	"./leagues/reports/user_affiliates/filterReports": 579,
	"./leagues/reports/user_affiliates/filterReports.js": 579,
	"./leagues/reports/user_affiliates/recordReports": 1575,
	"./leagues/reports/user_affiliates/recordReports.js": 1575,
	"./leagues/reports/user_affiliates/recordTableReports": 1576,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1576,
	"./leagues/reports/user_affiliates/tableReports": 580,
	"./leagues/reports/user_affiliates/tableReports.js": 580,
	"./leagues/results/recordTableResponts": 571,
	"./leagues/results/recordTableResponts.js": 571,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1577,
	"./leagues/statistics.js": 1577,
	"./leagues/statistics/age": 584,
	"./leagues/statistics/age.js": 584,
	"./leagues/statistics/marketing": 582,
	"./leagues/statistics/marketing.js": 582,
	"./leagues/statistics/marketingvsregistros": 583,
	"./leagues/statistics/marketingvsregistros.js": 583,
	"./leagues/statistics/money": 581,
	"./leagues/statistics/money.js": 581,
	"./limitationsReport": 1578,
	"./limitationsReport.js": 1578,
	"./loading": 1579,
	"./loading.js": 1579,
	"./login": 1580,
	"./login.js": 1580,
	"./logsUserGeneral": 1581,
	"./logsUserGeneral.js": 1581,
	"./loteryReport": 1582,
	"./loteryReport.js": 1582,
	"./loyaltyLevelChangeHistory": 1583,
	"./loyaltyLevelChangeHistory.js": 1583,
	"./machine/AddMachineRegister": 1584,
	"./machine/AddMachineRegister.js": 1584,
	"./machine/addMachineManagement": 1585,
	"./machine/addMachineManagement.js": 1585,
	"./machine/cashier/advertising": 594,
	"./machine/cashier/advertising.js": 594,
	"./machine/cashier/cashier": 1586,
	"./machine/cashier/cashier.js": 1586,
	"./machine/cashier/tableAdvertising": 595,
	"./machine/cashier/tableAdvertising.js": 595,
	"./machine/configuration": 1587,
	"./machine/configuration.js": 1587,
	"./machine/configuration/changePassword": 1588,
	"./machine/configuration/changePassword.js": 1588,
	"./machine/configuration/changePassword/changePasswordView": 1589,
	"./machine/configuration/changePassword/changePasswordView.js": 1589,
	"./machine/configuration/generateToken": 1590,
	"./machine/configuration/generateToken.js": 1590,
	"./machine/configuration/generateToken/filter": 1591,
	"./machine/configuration/generateToken/filter.js": 1591,
	"./machine/configuration/generateToken/table": 1592,
	"./machine/configuration/generateToken/table.js": 1592,
	"./machine/configuration/qrgoogle": 1593,
	"./machine/configuration/qrgoogle.js": 1593,
	"./machine/configuration/securityChanges": 1594,
	"./machine/configuration/securityChanges.js": 1594,
	"./machine/configuration/securityChanges/filter": 1029,
	"./machine/configuration/securityChanges/filter.js": 1029,
	"./machine/configuration/securityChanges/table": 596,
	"./machine/configuration/securityChanges/table.js": 596,
	"./machine/filter": 597,
	"./machine/filter.js": 597,
	"./machine/information": 1595,
	"./machine/information.js": 1595,
	"./machine/machineManagement": 1596,
	"./machine/machineManagement.js": 1596,
	"./machine/machineRegister": 1597,
	"./machine/machineRegister.js": 1597,
	"./machine/managePointsGraphics": 1598,
	"./machine/managePointsGraphics.js": 1598,
	"./machine/pagoNotaCobro": 1599,
	"./machine/pagoNotaCobro.js": 1599,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1030,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1030,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 601,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 601,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 602,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 602,
	"./machine/pagoPremioMaquina": 1600,
	"./machine/pagoPremioMaquina.js": 1600,
	"./machine/pagopremio/PagoPremio": 604,
	"./machine/pagopremio/PagoPremio.js": 604,
	"./machine/pagopremio/detailsPagoPremio": 606,
	"./machine/pagopremio/detailsPagoPremio.js": 606,
	"./machine/pagopremio/filterPagoPremio": 603,
	"./machine/pagopremio/filterPagoPremio.js": 603,
	"./machine/pagopremio/recordPagoPremio": 607,
	"./machine/pagopremio/recordPagoPremio.js": 607,
	"./machine/pagopremio/recordTablePagoPremio": 1601,
	"./machine/pagopremio/recordTablePagoPremio.js": 1601,
	"./machine/pagopremio/tablePagoPremio": 605,
	"./machine/pagopremio/tablePagoPremio.js": 605,
	"./machine/pointsGraphics/filter": 599,
	"./machine/pointsGraphics/filter.js": 599,
	"./machine/pointsGraphics/pointsList": 600,
	"./machine/pointsGraphics/pointsList.js": 600,
	"./machine/products2": 1602,
	"./machine/products2.js": 1602,
	"./machine/products2/categories-products/filter": 608,
	"./machine/products2/categories-products/filter.js": 608,
	"./machine/products2/categories-products/table": 609,
	"./machine/products2/categories-products/table.js": 609,
	"./machine/products2/categoriesProducts": 1603,
	"./machine/products2/categoriesProducts.js": 1603,
	"./machine/products2/partners-games/filter": 610,
	"./machine/products2/partners-games/filter.js": 610,
	"./machine/products2/partners-games/table": 611,
	"./machine/products2/partners-games/table.js": 611,
	"./machine/products2/partners-products/filter": 612,
	"./machine/products2/partners-products/filter.js": 612,
	"./machine/products2/partners-products/table": 613,
	"./machine/products2/partners-products/table.js": 613,
	"./machine/products2/partners-providers/filter": 614,
	"./machine/products2/partners-providers/filter.js": 614,
	"./machine/products2/partners-providers/table": 615,
	"./machine/products2/partners-providers/table.js": 615,
	"./machine/products2/partners-subProviders/filter": 616,
	"./machine/products2/partners-subProviders/filter.js": 616,
	"./machine/products2/partners-subProviders/table": 617,
	"./machine/products2/partners-subProviders/table.js": 617,
	"./machine/products2/partners-tipoproducto/filter": 618,
	"./machine/products2/partners-tipoproducto/filter.js": 618,
	"./machine/products2/partners-tipoproducto/table": 619,
	"./machine/products2/partners-tipoproducto/table.js": 619,
	"./machine/products2/partnersGames": 1604,
	"./machine/products2/partnersGames.js": 1604,
	"./machine/products2/partnersProducts": 1605,
	"./machine/products2/partnersProducts.js": 1605,
	"./machine/products2/partnersProviders": 1606,
	"./machine/products2/partnersProviders.js": 1606,
	"./machine/products2/partnersSubProviders": 1607,
	"./machine/products2/partnersSubProviders.js": 1607,
	"./machine/products2/partnersTypeProduct": 1608,
	"./machine/products2/partnersTypeProduct.js": 1608,
	"./machine/reports": 1609,
	"./machine/reports.js": 1609,
	"./machine/reports/betsReport": 1610,
	"./machine/reports/betsReport.js": 1610,
	"./machine/reports/betsReport/detailsReport": 1611,
	"./machine/reports/betsReport/detailsReport.js": 1611,
	"./machine/reports/betsReport/filterReport": 620,
	"./machine/reports/betsReport/filterReport.js": 620,
	"./machine/reports/betsReport/recordReport": 1612,
	"./machine/reports/betsReport/recordReport.js": 1612,
	"./machine/reports/betsReport/recordTableReport": 1613,
	"./machine/reports/betsReport/recordTableReport.js": 1613,
	"./machine/reports/betsReport/recordTableTransReport": 1614,
	"./machine/reports/betsReport/recordTableTransReport.js": 1614,
	"./machine/reports/betsReport/recordTransReport": 622,
	"./machine/reports/betsReport/recordTransReport.js": 622,
	"./machine/reports/betsReport/tableReport": 621,
	"./machine/reports/betsReport/tableReport.js": 621,
	"./machine/reports/casinoGamesReport": 1615,
	"./machine/reports/casinoGamesReport.js": 1615,
	"./machine/reports/casinoReport/detailsCasinoReport": 625,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 625,
	"./machine/reports/casinoReport/filterCasinoReport": 623,
	"./machine/reports/casinoReport/filterCasinoReport.js": 623,
	"./machine/reports/casinoReport/recordCasinoReport": 626,
	"./machine/reports/casinoReport/recordCasinoReport.js": 626,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1616,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1616,
	"./machine/reports/casinoReport/tableCasinoReport": 624,
	"./machine/reports/casinoReport/tableCasinoReport.js": 624,
	"./machine/reports/depositReport": 1617,
	"./machine/reports/depositReport.js": 1617,
	"./machine/reports/deposit_report/detailsDepositReports": 1031,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1031,
	"./machine/reports/deposit_report/filterDepositReports": 627,
	"./machine/reports/deposit_report/filterDepositReports.js": 627,
	"./machine/reports/deposit_report/recordDepositReports": 629,
	"./machine/reports/deposit_report/recordDepositReports.js": 629,
	"./machine/reports/deposit_report/recordTableDepositReports": 1618,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1618,
	"./machine/reports/deposit_report/tableDepositReports": 628,
	"./machine/reports/deposit_report/tableDepositReports.js": 628,
	"./machine/reports/flujoCaja": 1619,
	"./machine/reports/flujoCaja.js": 1619,
	"./machine/reports/flujocaja/detailsFlujoCaja": 632,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 632,
	"./machine/reports/flujocaja/filterFlujoCaja": 630,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 630,
	"./machine/reports/flujocaja/recordFlujoCaja": 633,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 633,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1620,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1620,
	"./machine/reports/flujocaja/tableFlujoCaja": 631,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 631,
	"./machine/reports/log/log": 634,
	"./machine/reports/log/log.js": 634,
	"./machine/reports/logReport": 1621,
	"./machine/reports/logReport.js": 1621,
	"./machine/reports/updates/filter": 635,
	"./machine/reports/updates/filter.js": 635,
	"./machine/reports/updates/table": 636,
	"./machine/reports/updates/table.js": 636,
	"./machine/reports/updatesReport": 1622,
	"./machine/reports/updatesReport.js": 1622,
	"./machine/reports/userAfilliatesReport": 1623,
	"./machine/reports/userAfilliatesReport.js": 1623,
	"./machine/reports/user_affiliates/detailsReports": 1624,
	"./machine/reports/user_affiliates/detailsReports.js": 1624,
	"./machine/reports/user_affiliates/filterReports": 637,
	"./machine/reports/user_affiliates/filterReports.js": 637,
	"./machine/reports/user_affiliates/recordReports": 1625,
	"./machine/reports/user_affiliates/recordReports.js": 1625,
	"./machine/reports/user_affiliates/recordTableReports": 1626,
	"./machine/reports/user_affiliates/recordTableReports.js": 1626,
	"./machine/reports/user_affiliates/tableReports": 638,
	"./machine/reports/user_affiliates/tableReports.js": 638,
	"./machine/reports/withdrawalRequests": 1627,
	"./machine/reports/withdrawalRequests.js": 1627,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 641,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 641,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 639,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 639,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1628,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1628,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 642,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 642,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 640,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 640,
	"./machine/results/recordTableResponts": 1629,
	"./machine/results/recordTableResponts.js": 1629,
	"./machine/results/tableResults": 1630,
	"./machine/results/tableResults.js": 1630,
	"./machine/statistics": 1631,
	"./machine/statistics.js": 1631,
	"./machine/statistics/age": 646,
	"./machine/statistics/age.js": 646,
	"./machine/statistics/marketing": 644,
	"./machine/statistics/marketing.js": 644,
	"./machine/statistics/marketingvsregistros": 645,
	"./machine/statistics/marketingvsregistros.js": 645,
	"./machine/statistics/money": 643,
	"./machine/statistics/money.js": 643,
	"./machine/table": 598,
	"./machine/table.js": 598,
	"./management/activateRegistration/filter": 203,
	"./management/activateRegistration/filter.js": 203,
	"./management/activateRegistration/response": 204,
	"./management/activateRegistration/response.js": 204,
	"./management/coupons/coupons": 446,
	"./management/coupons/coupons.js": 446,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 511,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 511,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 510,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 510,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 513,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 513,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 512,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 512,
	"./management/faltan.txt": 1961,
	"./management/managementClaims/filter": 647,
	"./management/managementClaims/filter.js": 647,
	"./management/managementClaims/table": 648,
	"./management/managementClaims/table.js": 648,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 649,
	"./management/managementContact/detailsTable.js": 649,
	"./management/managementContact/filterManagementContact": 650,
	"./management/managementContact/filterManagementContact.js": 650,
	"./management/managementContact/tableManagementContact": 651,
	"./management/managementContact/tableManagementContact.js": 651,
	"./management/managementContactUser/filter": 652,
	"./management/managementContactUser/filter.js": 652,
	"./management/managementContactUser/table": 653,
	"./management/managementContactUser/table.js": 653,
	"./management/managementGenericForms/filter": 654,
	"./management/managementGenericForms/filter.js": 654,
	"./management/managementGenericForms/table": 655,
	"./management/managementGenericForms/table.js": 655,
	"./management/quotaRetraction/Retraction": 656,
	"./management/quotaRetraction/Retraction.js": 656,
	"./management/quotaRetraction/search": 1032,
	"./management/quotaRetraction/search.js": 1032,
	"./management/registerFast/filterRegisterFast": 657,
	"./management/registerFast/filterRegisterFast.js": 657,
	"./management/registerFast/tableRegisterFast": 658,
	"./management/registerFast/tableRegisterFast.js": 658,
	"./management/reprintCheck/filterReprintCheck": 659,
	"./management/reprintCheck/filterReprintCheck.js": 659,
	"./management/reprintCheck/tableReprintCheck": 660,
	"./management/reprintCheck/tableReprintCheck.js": 660,
	"./management/restrictUser/filter": 661,
	"./management/restrictUser/filter.js": 661,
	"./management/restrictUser/table": 662,
	"./management/restrictUser/table.js": 662,
	"./management/reversionReload/filterReversionReload": 663,
	"./management/reversionReload/filterReversionReload.js": 663,
	"./management/reversionReload/tableReversionReload": 664,
	"./management/reversionReload/tableReversionReload.js": 664,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 665,
	"./management/usersVerification/informationJumio.js": 665,
	"./managementClaims": 1632,
	"./managementClaims.js": 1632,
	"./managementContact": 1633,
	"./managementContact.js": 1633,
	"./managementContactUser": 1634,
	"./managementContactUser.js": 1634,
	"./managementGenericForms": 1635,
	"./managementGenericForms.js": 1635,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1636,
	"./menuBonus.js": 1636,
	"./menuBuilder": 1637,
	"./menuBuilder.js": 1637,
	"./menuMarketing": 1638,
	"./menuMarketing.js": 1638,
	"./menus": 1639,
	"./menus.js": 1639,
	"./messages/bannerInvasive": 1640,
	"./messages/bannerInvasive.js": 1640,
	"./messages/bannerInvasive/filter": 668,
	"./messages/bannerInvasive/filter.js": 668,
	"./messages/bannerInvasive/table": 669,
	"./messages/bannerInvasive/table.js": 669,
	"./messages/fringe": 1641,
	"./messages/fringe.js": 1641,
	"./messages/fringe/filter": 670,
	"./messages/fringe/filter.js": 670,
	"./messages/fringe/table": 671,
	"./messages/fringe/table.js": 671,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 672,
	"./messages/messageInternAgent/filter.js": 672,
	"./messages/messageInternAgent/table": 673,
	"./messages/messageInternAgent/table.js": 673,
	"./messages/messageInternal": 1642,
	"./messages/messageInternal.js": 1642,
	"./messages/messageInternalAgent": 1643,
	"./messages/messageInternalAgent.js": 1643,
	"./messages/messageList": 1644,
	"./messages/messageList.js": 1644,
	"./messages/popup": 1645,
	"./messages/popup.js": 1645,
	"./messages/popup/filter": 674,
	"./messages/popup/filter.js": 674,
	"./messages/popup/table": 675,
	"./messages/popup/table.js": 675,
	"./messagesOld/messageIntern/filter": 1646,
	"./messagesOld/messageIntern/filter.js": 1646,
	"./messagesOld/messageIntern/table": 1647,
	"./messagesOld/messageIntern/table.js": 1647,
	"./messagesOld/messageList": 1648,
	"./messagesOld/messageList.js": 1648,
	"./myComissionsReport": 1649,
	"./myComissionsReport.js": 1649,
	"./myConfiguration/changeMyPassword": 1650,
	"./myConfiguration/changeMyPassword.js": 1650,
	"./myConfiguration/myInfoBetShop": 1651,
	"./myConfiguration/myInfoBetShop.js": 1651,
	"./myConfiguration/myInfoCustomer": 1652,
	"./myConfiguration/myInfoCustomer.js": 1652,
	"./myConfiguration/myInformation": 1653,
	"./myConfiguration/myInformation.js": 1653,
	"./myConfiguration/qrgoogle": 1654,
	"./myConfiguration/qrgoogle.js": 1654,
	"./notesUser": 1655,
	"./notesUser.js": 1655,
	"./notifications": 1003,
	"./notifications.js": 1003,
	"./operatorResponsibility": 1656,
	"./operatorResponsibility.js": 1656,
	"./ownersIncome": 1657,
	"./ownersIncome.js": 1657,
	"./ownersIncomeSecondLevel": 1658,
	"./ownersIncomeSecondLevel.js": 1658,
	"./pagoNotaRetiro": 1659,
	"./pagoNotaRetiro.js": 1659,
	"./pagoPremio": 1660,
	"./pagoPremio.js": 1660,
	"./pagoPremioVirtuales": 1661,
	"./pagoPremioVirtuales.js": 1661,
	"./paidPendingAwards": 1662,
	"./paidPendingAwards.js": 1662,
	"./partner/PartnerSettings": 1663,
	"./partner/PartnerSettings.js": 1663,
	"./partner/PartnerSettingsOld": 1664,
	"./partner/PartnerSettingsOld.js": 1664,
	"./partner/TRM": 1665,
	"./partner/TRM.js": 1665,
	"./partner/TRM/filter": 690,
	"./partner/TRM/filter.js": 690,
	"./partner/TRM/table": 691,
	"./partner/TRM/table.js": 691,
	"./partner/configuration": 1666,
	"./partner/configuration.js": 1666,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1667,
	"./partner/configurationControl.js": 1667,
	"./partner/configurationControl/filter": 692,
	"./partner/configurationControl/filter.js": 692,
	"./partner/configurationControl/table": 693,
	"./partner/configurationControl/table.js": 693,
	"./partner/configurationControl2": 1668,
	"./partner/configurationControl2.js": 1668,
	"./partner/configurationControl2/filter": 694,
	"./partner/configurationControl2/filter.js": 694,
	"./partner/configurationControl2/table": 695,
	"./partner/configurationControl2/table.js": 695,
	"./partner/configurationOld/filter": 1669,
	"./partner/configurationOld/filter.js": 1669,
	"./partner/configurationOld/settings": 1670,
	"./partner/configurationOld/settings.js": 1670,
	"./partner/configurationSEO": 1671,
	"./partner/configurationSEO.js": 1671,
	"./partner/configurationSEO/filter": 696,
	"./partner/configurationSEO/filter.js": 696,
	"./partner/configurationSEO/settings": 697,
	"./partner/configurationSEO/settings.js": 697,
	"./partner/countries": 1672,
	"./partner/countries.js": 1672,
	"./partner/countries/countries": 698,
	"./partner/countries/countries.js": 698,
	"./partner/menusUser": 1673,
	"./partner/menusUser.js": 1673,
	"./partner/menusUser/filter": 699,
	"./partner/menusUser/filter.js": 699,
	"./partner/menusUser/table": 700,
	"./partner/menusUser/table.js": 700,
	"./partner/partner-list/filter": 688,
	"./partner/partner-list/filter.js": 688,
	"./partner/partner-list/table": 689,
	"./partner/partner-list/table.js": 689,
	"./partner/partnertManagement": 1674,
	"./partner/partnertManagement.js": 1674,
	"./partner/products": 1675,
	"./partner/products.js": 1675,
	"./partner/products/categories-products/filter": 701,
	"./partner/products/categories-products/filter.js": 701,
	"./partner/products/categories-products/table": 702,
	"./partner/products/categories-products/table.js": 702,
	"./partner/products/categoriesProducts": 1676,
	"./partner/products/categoriesProducts.js": 1676,
	"./partner/products/partners-products/filter": 703,
	"./partner/products/partners-products/filter.js": 703,
	"./partner/products/partners-products/table": 704,
	"./partner/products/partners-products/table.js": 704,
	"./partner/products/partners-providers/filter": 705,
	"./partner/products/partners-providers/filter.js": 705,
	"./partner/products/partners-providers/table": 706,
	"./partner/products/partners-providers/table.js": 706,
	"./partner/products/partners-subProviders/filter": 707,
	"./partner/products/partners-subProviders/filter.js": 707,
	"./partner/products/partners-subProviders/table": 708,
	"./partner/products/partners-subProviders/table.js": 708,
	"./partner/products/partners-tipoproducto/filter": 709,
	"./partner/products/partners-tipoproducto/filter.js": 709,
	"./partner/products/partners-tipoproducto/table": 710,
	"./partner/products/partners-tipoproducto/table.js": 710,
	"./partner/products/partnersProducts": 1677,
	"./partner/products/partnersProducts.js": 1677,
	"./partner/products/partnersProviders": 1678,
	"./partner/products/partnersProviders.js": 1678,
	"./partner/products/partnersSubProviders": 1679,
	"./partner/products/partnersSubProviders.js": 1679,
	"./partner/products/partnersTypeProduct": 1680,
	"./partner/products/partnersTypeProduct.js": 1680,
	"./partner/products/products-banks/filter": 711,
	"./partner/products/products-banks/filter.js": 711,
	"./partner/products/products-banks/table": 712,
	"./partner/products/products-banks/table.js": 712,
	"./partner/products/products-cryptoNetwork/filter": 713,
	"./partner/products/products-cryptoNetwork/filter.js": 713,
	"./partner/products/products-cryptoNetwork/table": 714,
	"./partner/products/products-cryptoNetwork/table.js": 714,
	"./partner/products/products-franchises/filter": 715,
	"./partner/products/products-franchises/filter.js": 715,
	"./partner/products/products-franchises/table": 716,
	"./partner/products/products-franchises/table.js": 716,
	"./partner/products/productsBanks": 1681,
	"./partner/products/productsBanks.js": 1681,
	"./partner/products/productsCryptoNetwork": 1682,
	"./partner/products/productsCryptoNetwork.js": 1682,
	"./partner/products/productsFranchises": 1683,
	"./partner/products/productsFranchises.js": 1683,
	"./partner/products2": 1684,
	"./partner/products2.js": 1684,
	"./partner/products2/banks-partners/filter": 717,
	"./partner/products2/banks-partners/filter.js": 717,
	"./partner/products2/banks-partners/table": 718,
	"./partner/products2/banks-partners/table.js": 718,
	"./partner/products2/categories-products/filter": 719,
	"./partner/products2/categories-products/filter.js": 719,
	"./partner/products2/categories-products/table": 720,
	"./partner/products2/categories-products/table.js": 720,
	"./partner/products2/categoriesProducts": 1685,
	"./partner/products2/categoriesProducts.js": 1685,
	"./partner/products2/enablement-products/filter": 721,
	"./partner/products2/enablement-products/filter.js": 721,
	"./partner/products2/enablement-products/table": 722,
	"./partner/products2/enablement-products/table.js": 722,
	"./partner/products2/enablementProducts": 1686,
	"./partner/products2/enablementProducts.js": 1686,
	"./partner/products2/franchises-partner/filter": 723,
	"./partner/products2/franchises-partner/filter.js": 723,
	"./partner/products2/franchises-partner/table": 724,
	"./partner/products2/franchises-partner/table.js": 724,
	"./partner/products2/partners-categories/filter": 725,
	"./partner/products2/partners-categories/filter.js": 725,
	"./partner/products2/partners-categories/table": 726,
	"./partner/products2/partners-categories/table.js": 726,
	"./partner/products2/partners-credentialsSubProviders/filter": 727,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 727,
	"./partner/products2/partners-credentialsSubProviders/table": 728,
	"./partner/products2/partners-credentialsSubProviders/table.js": 728,
	"./partner/products2/partners-games/filter": 729,
	"./partner/products2/partners-games/filter.js": 729,
	"./partner/products2/partners-games/table": 730,
	"./partner/products2/partners-games/table.js": 730,
	"./partner/products2/partners-products/filter": 731,
	"./partner/products2/partners-products/filter.js": 731,
	"./partner/products2/partners-products/table": 732,
	"./partner/products2/partners-products/table.js": 732,
	"./partner/products2/partners-providers-order/filter": 1687,
	"./partner/products2/partners-providers-order/filter.js": 1687,
	"./partner/products2/partners-providers-order/table": 1688,
	"./partner/products2/partners-providers-order/table.js": 1688,
	"./partner/products2/partners-providers/filter": 733,
	"./partner/products2/partners-providers/filter.js": 733,
	"./partner/products2/partners-providers/table": 734,
	"./partner/products2/partners-providers/table.js": 734,
	"./partner/products2/partners-subProviders-order/filter": 735,
	"./partner/products2/partners-subProviders-order/filter.js": 735,
	"./partner/products2/partners-subProviders-order/table": 736,
	"./partner/products2/partners-subProviders-order/table.js": 736,
	"./partner/products2/partners-subProviders/filter": 737,
	"./partner/products2/partners-subProviders/filter.js": 737,
	"./partner/products2/partners-subProviders/table": 738,
	"./partner/products2/partners-subProviders/table.js": 738,
	"./partner/products2/partners-tipoproducto/filter": 739,
	"./partner/products2/partners-tipoproducto/filter.js": 739,
	"./partner/products2/partners-tipoproducto/table": 740,
	"./partner/products2/partners-tipoproducto/table.js": 740,
	"./partner/products2/partnersBanks": 1689,
	"./partner/products2/partnersBanks.js": 1689,
	"./partner/products2/partnersCategories": 1690,
	"./partner/products2/partnersCategories.js": 1690,
	"./partner/products2/partnersCredentialsSubProviders": 1691,
	"./partner/products2/partnersCredentialsSubProviders.js": 1691,
	"./partner/products2/partnersFranchises": 1692,
	"./partner/products2/partnersFranchises.js": 1692,
	"./partner/products2/partnersGames": 1693,
	"./partner/products2/partnersGames.js": 1693,
	"./partner/products2/partnersProducts": 1694,
	"./partner/products2/partnersProducts.js": 1694,
	"./partner/products2/partnersProviders": 1695,
	"./partner/products2/partnersProviders.js": 1695,
	"./partner/products2/partnersSubProviders": 1696,
	"./partner/products2/partnersSubProviders.js": 1696,
	"./partner/products2/partnersSubProvidersOrder": 1697,
	"./partner/products2/partnersSubProvidersOrder.js": 1697,
	"./partner/products2/partnersTypeProduct": 1698,
	"./partner/products2/partnersTypeProduct.js": 1698,
	"./partner/reports": 1699,
	"./partner/reports.js": 1699,
	"./partner/reports/autoexclusionUsers": 1700,
	"./partner/reports/autoexclusionUsers.js": 1700,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 743,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 743,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 741,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 741,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1033,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1033,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 744,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 744,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 742,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 742,
	"./partner/reports/balanceAdjustments": 1701,
	"./partner/reports/balanceAdjustments.js": 1701,
	"./partner/reports/balanceAdjustments/filter": 745,
	"./partner/reports/balanceAdjustments/filter.js": 745,
	"./partner/reports/balanceAdjustments/table": 746,
	"./partner/reports/balanceAdjustments/table.js": 746,
	"./partner/reports/balanceHistory": 1702,
	"./partner/reports/balanceHistory.js": 1702,
	"./partner/reports/balanceHistory/filter": 747,
	"./partner/reports/balanceHistory/filter.js": 747,
	"./partner/reports/balanceHistory/table": 748,
	"./partner/reports/balanceHistory/table.js": 748,
	"./partner/reports/balanceHistoryBetShop": 1703,
	"./partner/reports/balanceHistoryBetShop.js": 1703,
	"./partner/reports/balanceHistoryBetShop/filter": 749,
	"./partner/reports/balanceHistoryBetShop/filter.js": 749,
	"./partner/reports/balanceHistoryBetShop/table": 750,
	"./partner/reports/balanceHistoryBetShop/table.js": 750,
	"./partner/reports/balanceUsers": 1704,
	"./partner/reports/balanceUsers.js": 1704,
	"./partner/reports/balanceUsers/filter": 751,
	"./partner/reports/balanceUsers/filter.js": 751,
	"./partner/reports/balanceUsers/record": 753,
	"./partner/reports/balanceUsers/record.js": 753,
	"./partner/reports/balanceUsers/resume": 754,
	"./partner/reports/balanceUsers/resume.js": 754,
	"./partner/reports/balanceUsers/table": 752,
	"./partner/reports/balanceUsers/table.js": 752,
	"./partner/reports/betsReport": 1705,
	"./partner/reports/betsReport.js": 1705,
	"./partner/reports/betsReport/detailsReport": 1706,
	"./partner/reports/betsReport/detailsReport.js": 1706,
	"./partner/reports/betsReport/filterReport": 755,
	"./partner/reports/betsReport/filterReport.js": 755,
	"./partner/reports/betsReport/recordReport": 759,
	"./partner/reports/betsReport/recordReport.js": 759,
	"./partner/reports/betsReport/recordTableReport": 760,
	"./partner/reports/betsReport/recordTableReport.js": 760,
	"./partner/reports/betsReport/recordTableTransReport": 758,
	"./partner/reports/betsReport/recordTableTransReport.js": 758,
	"./partner/reports/betsReport/recordTransReport": 757,
	"./partner/reports/betsReport/recordTransReport.js": 757,
	"./partner/reports/betsReport/tableReport": 756,
	"./partner/reports/betsReport/tableReport.js": 756,
	"./partner/reports/bonusReport": 1707,
	"./partner/reports/bonusReport.js": 1707,
	"./partner/reports/bonusReport/detailsBonusReport": 763,
	"./partner/reports/bonusReport/detailsBonusReport.js": 763,
	"./partner/reports/bonusReport/filterBonusReport": 761,
	"./partner/reports/bonusReport/filterBonusReport.js": 761,
	"./partner/reports/bonusReport/recordBonusReport": 764,
	"./partner/reports/bonusReport/recordBonusReport.js": 764,
	"./partner/reports/bonusReport/recordTableBonusReport": 765,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 765,
	"./partner/reports/bonusReport/tableBonusReport": 762,
	"./partner/reports/bonusReport/tableBonusReport.js": 762,
	"./partner/reports/casinoGamesReport": 1708,
	"./partner/reports/casinoGamesReport.js": 1708,
	"./partner/reports/casinoReport/detailsCasinoReport": 768,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 768,
	"./partner/reports/casinoReport/filterCasinoReport": 766,
	"./partner/reports/casinoReport/filterCasinoReport.js": 766,
	"./partner/reports/casinoReport/recordCasinoReport": 769,
	"./partner/reports/casinoReport/recordCasinoReport.js": 769,
	"./partner/reports/casinoReport/recordTableCasinoReport": 770,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 770,
	"./partner/reports/casinoReport/tableCasinoReport": 767,
	"./partner/reports/casinoReport/tableCasinoReport.js": 767,
	"./partner/reports/comissionsReport": 1709,
	"./partner/reports/comissionsReport.js": 1709,
	"./partner/reports/comissions_report/filter": 771,
	"./partner/reports/comissions_report/filter.js": 771,
	"./partner/reports/comissions_report/table": 772,
	"./partner/reports/comissions_report/table.js": 772,
	"./partner/reports/depositReport": 1710,
	"./partner/reports/depositReport.js": 1710,
	"./partner/reports/deposit_report/detailsDepositReports": 1034,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1034,
	"./partner/reports/deposit_report/filterDepositReports": 773,
	"./partner/reports/deposit_report/filterDepositReports.js": 773,
	"./partner/reports/deposit_report/recordDepositReports": 775,
	"./partner/reports/deposit_report/recordDepositReports.js": 775,
	"./partner/reports/deposit_report/recordTableDepositReports": 776,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 776,
	"./partner/reports/deposit_report/tableDepositReports": 774,
	"./partner/reports/deposit_report/tableDepositReports.js": 774,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 777,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 777,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 778,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 778,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 779,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 779,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 780,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 780,
	"./partner/reports/historicalCashFlow": 1711,
	"./partner/reports/historicalCashFlow.js": 1711,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 783,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 783,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 781,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 781,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 784,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 784,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 785,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 785,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 782,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 782,
	"./partner/reports/historyMovement": 1712,
	"./partner/reports/historyMovement.js": 1712,
	"./partner/reports/historyMovement/filter": 786,
	"./partner/reports/historyMovement/filter.js": 786,
	"./partner/reports/historyMovement/table": 787,
	"./partner/reports/historyMovement/table.js": 787,
	"./partner/reports/informeCasino/detailsInformeCasino": 1713,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1713,
	"./partner/reports/informeCasino/filterInformeCasino": 1714,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1714,
	"./partner/reports/informeCasino/recordInformeCasino": 1715,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1715,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1716,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1716,
	"./partner/reports/informeCasino/tableInformeCasino": 1717,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1717,
	"./partner/reports/informeGerencial": 1718,
	"./partner/reports/informeGerencial.js": 1718,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 790,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 790,
	"./partner/reports/informeGerencial/filterInformeGerencial": 788,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 788,
	"./partner/reports/informeGerencial/recordInformeGerencial": 791,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 791,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 792,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 792,
	"./partner/reports/informeGerencial/tableInformeGerencial": 789,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 789,
	"./partner/reports/landingReport/detailsLandingReport": 1719,
	"./partner/reports/landingReport/detailsLandingReport.js": 1719,
	"./partner/reports/landingReport/filterLandingReport": 1720,
	"./partner/reports/landingReport/filterLandingReport.js": 1720,
	"./partner/reports/landingReport/recordLandingReport": 1721,
	"./partner/reports/landingReport/recordLandingReport.js": 1721,
	"./partner/reports/landingReport/recordTableLandingReport": 1722,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1722,
	"./partner/reports/landingReport/tableLandingReport": 1723,
	"./partner/reports/landingReport/tableLandingReport.js": 1723,
	"./partner/reports/logsUser/filter": 1724,
	"./partner/reports/logsUser/filter.js": 1724,
	"./partner/reports/logsUser/table": 1725,
	"./partner/reports/logsUser/table.js": 1725,
	"./partner/reports/operatorResponsibility/filter": 1726,
	"./partner/reports/operatorResponsibility/filter.js": 1726,
	"./partner/reports/operatorResponsibility/table": 1727,
	"./partner/reports/operatorResponsibility/table.js": 1727,
	"./partner/reports/paidPendingAwards": 1728,
	"./partner/reports/paidPendingAwards.js": 1728,
	"./partner/reports/playersReport/detailsPlayersReport": 1729,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1729,
	"./partner/reports/playersReport/filterPlayersReport": 1730,
	"./partner/reports/playersReport/filterPlayersReport.js": 1730,
	"./partner/reports/playersReport/recordPlayersReport": 1731,
	"./partner/reports/playersReport/recordPlayersReport.js": 1731,
	"./partner/reports/playersReport/recordTablePlayersReport": 796,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 796,
	"./partner/reports/playersReport/tablePlayersReport": 1732,
	"./partner/reports/playersReport/tablePlayersReport.js": 1732,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1035,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1035,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 793,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 793,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1036,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1036,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 795,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 795,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 794,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 794,
	"./partner/reports/promotionalCodes/filter": 1733,
	"./partner/reports/promotionalCodes/filter.js": 1733,
	"./partner/reports/promotionalCodes/table": 1734,
	"./partner/reports/promotionalCodes/table.js": 1734,
	"./partner/reports/quotaRetraction/filter": 1735,
	"./partner/reports/quotaRetraction/filter.js": 1735,
	"./partner/reports/quotaRetraction/table": 1736,
	"./partner/reports/quotaRetraction/table.js": 1736,
	"./partner/reports/registeredDocument": 1737,
	"./partner/reports/registeredDocument.js": 1737,
	"./partner/reports/registeredDocuments/filter": 797,
	"./partner/reports/registeredDocuments/filter.js": 797,
	"./partner/reports/registeredDocuments/table": 798,
	"./partner/reports/registeredDocuments/table.js": 798,
	"./partner/reports/relationUserAggregator": 1738,
	"./partner/reports/relationUserAggregator.js": 1738,
	"./partner/reports/relationUserAggregator/filter": 799,
	"./partner/reports/relationUserAggregator/filter.js": 799,
	"./partner/reports/relationUserAggregator/table": 800,
	"./partner/reports/relationUserAggregator/table.js": 800,
	"./partner/reports/reportHash/filter": 1739,
	"./partner/reports/reportHash/filter.js": 1739,
	"./partner/reports/reportHash/table": 1740,
	"./partner/reports/reportHash/table.js": 1740,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1741,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1741,
	"./partner/reports/sessionsReport/filterSessionsReport": 1742,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1742,
	"./partner/reports/sessionsReport/recordSessionsReport": 1743,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1743,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1037,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1037,
	"./partner/reports/sessionsReport/tableSessionsReport": 1744,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1744,
	"./partner/reports/sportsTransactions": 1745,
	"./partner/reports/sportsTransactions.js": 1745,
	"./partner/reports/sportsTransactions/filter": 801,
	"./partner/reports/sportsTransactions/filter.js": 801,
	"./partner/reports/sportsTransactions/table": 802,
	"./partner/reports/sportsTransactions/table.js": 802,
	"./partner/reports/summaryCashFlow": 1746,
	"./partner/reports/summaryCashFlow.js": 1746,
	"./partner/reports/taxableEarnings/filter": 1747,
	"./partner/reports/taxableEarnings/filter.js": 1747,
	"./partner/reports/taxableEarnings/table": 1748,
	"./partner/reports/taxableEarnings/table.js": 1748,
	"./partner/reports/transfersReport/filter": 1749,
	"./partner/reports/transfersReport/filter.js": 1749,
	"./partner/reports/transfersReport/table": 1750,
	"./partner/reports/transfersReport/table.js": 1750,
	"./partner/reports/usuarioOnlineResumido": 1751,
	"./partner/reports/usuarioOnlineResumido.js": 1751,
	"./partner/reports/usuarioOnlineResumido/filter": 803,
	"./partner/reports/usuarioOnlineResumido/filter.js": 803,
	"./partner/reports/usuarioOnlineResumido/table": 804,
	"./partner/reports/usuarioOnlineResumido/table.js": 804,
	"./partner/reports/wallets": 1752,
	"./partner/reports/wallets.js": 1752,
	"./partner/reports/wallets/filter": 805,
	"./partner/reports/wallets/filter.js": 805,
	"./partner/reports/wallets/table": 806,
	"./partner/reports/wallets/table.js": 806,
	"./partner/templates": 1753,
	"./partner/templates.js": 1753,
	"./partner/templates/email": 1754,
	"./partner/templates/email.js": 1754,
	"./partner/templates/email/filter": 807,
	"./partner/templates/email/filter.js": 807,
	"./partner/templates/email/table": 808,
	"./partner/templates/email/table.js": 808,
	"./partner/templates/email/template": 809,
	"./partner/templates/email/template.js": 809,
	"./partner/templates/emailTemplate": 1755,
	"./partner/templates/emailTemplate.js": 1755,
	"./partner/templates/pdf": 1756,
	"./partner/templates/pdf.js": 1756,
	"./partner/templates/pdf/filter": 810,
	"./partner/templates/pdf/filter.js": 810,
	"./partner/templates/pdf/table": 811,
	"./partner/templates/pdf/table.js": 811,
	"./partner/templates/pdf/template": 812,
	"./partner/templates/pdf/template.js": 812,
	"./partner/templates/pdfTemplate": 1757,
	"./partner/templates/pdfTemplate.js": 1757,
	"./partner/templates/sms": 1758,
	"./partner/templates/sms.js": 1758,
	"./partner/templates/sms/filter": 813,
	"./partner/templates/sms/filter.js": 813,
	"./partner/templates/sms/table": 814,
	"./partner/templates/sms/table.js": 814,
	"./partner/templates/sms/template": 815,
	"./partner/templates/sms/template.js": 815,
	"./partner/templates/smsTemplate": 1759,
	"./partner/templates/smsTemplate.js": 1759,
	"./partners": 1760,
	"./partners.js": 1760,
	"./partnersCategories": 1761,
	"./partnersCategories.js": 1761,
	"./partnersProducts": 1762,
	"./partnersProducts.js": 1762,
	"./partnersProductsCountry": 1763,
	"./partnersProductsCountry.js": 1763,
	"./partnersProviders": 1764,
	"./partnersProviders.js": 1764,
	"./partnersTypeProduct": 1765,
	"./partnersTypeProduct.js": 1765,
	"./payPrizesLoyalty": 1766,
	"./payPrizesLoyalty.js": 1766,
	"./payhistoryview": 1767,
	"./payhistoryview.js": 1767,
	"./platformSpecific": 1768,
	"./platformSpecific.js": 1768,
	"./platformSpecific2": 1769,
	"./platformSpecific2.js": 1769,
	"./playerAccount": 1770,
	"./playerAccount.js": 1770,
	"./playerAccount2": 1771,
	"./playerAccount2.js": 1771,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1772,
	"./playersList.js": 1772,
	"./playersList2": 1773,
	"./playersList2.js": 1773,
	"./playersListAggregator": 1774,
	"./playersListAggregator.js": 1774,
	"./playersLists": 1775,
	"./playersLists.js": 1775,
	"./playersReport": 1776,
	"./playersReport.js": 1776,
	"./pointSettings": 1777,
	"./pointSettings.js": 1777,
	"./pointsUsers": 1778,
	"./pointsUsers.js": 1778,
	"./pokerReport": 1779,
	"./pokerReport.js": 1779,
	"./prices": 1780,
	"./prices.js": 1780,
	"./prizesLoyalty": 1781,
	"./prizesLoyalty.js": 1781,
	"./products": 1782,
	"./products.js": 1782,
	"./products/activeProviders/filterActiveProviders": 205,
	"./products/activeProviders/filterActiveProviders.js": 205,
	"./products/activeProviders/tableActiveProviders": 206,
	"./products/activeProviders/tableActiveProviders.js": 206,
	"./products/banks/filterBanks": 323,
	"./products/banks/filterBanks.js": 323,
	"./products/banks/tableBanks": 324,
	"./products/banks/tableBanks.js": 324,
	"./products/blockchain-networks/filterBlockchainNetworks": 380,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 380,
	"./products/blockchain-networks/tableBlockchainNetworks": 381,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 381,
	"./products/categories-products/detailsCategoriesProducts": 1020,
	"./products/categories-products/detailsCategoriesProducts.js": 1020,
	"./products/categories-products/filterCategoriesProducts": 425,
	"./products/categories-products/filterCategoriesProducts.js": 425,
	"./products/categories-products/recordCategoriesProducts": 1021,
	"./products/categories-products/recordCategoriesProducts.js": 1021,
	"./products/categories-products/recordTableCategoriesProducts": 427,
	"./products/categories-products/recordTableCategoriesProducts.js": 427,
	"./products/categories-products/tableCategoriesProducts": 426,
	"./products/categories-products/tableCategoriesProducts.js": 426,
	"./products/categories/detailsCategories": 1018,
	"./products/categories/detailsCategories.js": 1018,
	"./products/categories/filterCategories": 422,
	"./products/categories/filterCategories.js": 422,
	"./products/categories/recordCategories": 1019,
	"./products/categories/recordCategories.js": 1019,
	"./products/categories/recordTableCategories": 424,
	"./products/categories/recordTableCategories.js": 424,
	"./products/categories/tableCategories": 423,
	"./products/categories/tableCategories.js": 423,
	"./products/crypto-blockchain/filterCryptoBlockchain": 449,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 449,
	"./products/crypto-blockchain/tableCryptoBlockchain": 450,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 450,
	"./products/cryptos/filterCrypto": 451,
	"./products/cryptos/filterCrypto.js": 451,
	"./products/cryptos/tableCrypto": 452,
	"./products/cryptos/tableCrypto.js": 452,
	"./products/franchises/filterFranchises": 520,
	"./products/franchises/filterFranchises.js": 520,
	"./products/franchises/tableFranchises": 521,
	"./products/franchises/tableFranchises.js": 521,
	"./products/partners-products-country/detailsPartnersProductsCountry": 826,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 826,
	"./products/partners-products-country/filterPartnersProductsCountry": 824,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 824,
	"./products/partners-products-country/recordPartnersProductsCountry": 827,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 827,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 828,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 828,
	"./products/partners-products-country/tablePartnersProductsCountry": 825,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 825,
	"./products/partners-products/detailsPartnersProducts": 822,
	"./products/partners-products/detailsPartnersProducts.js": 822,
	"./products/partners-products/filterPartnersProducts": 820,
	"./products/partners-products/filterPartnersProducts.js": 820,
	"./products/partners-products/recordPartnersProducts": 823,
	"./products/partners-products/recordPartnersProducts.js": 823,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 821,
	"./products/partners-products/tablePartnersProducts.js": 821,
	"./products/partners-providers/details": 831,
	"./products/partners-providers/details.js": 831,
	"./products/partners-providers/filter": 829,
	"./products/partners-providers/filter.js": 829,
	"./products/partners-providers/record": 832,
	"./products/partners-providers/record.js": 832,
	"./products/partners-providers/recordTable": 1783,
	"./products/partners-providers/recordTable.js": 1783,
	"./products/partners-providers/table": 830,
	"./products/partners-providers/table.js": 830,
	"./products/partners-tipoproducto/details": 835,
	"./products/partners-tipoproducto/details.js": 835,
	"./products/partners-tipoproducto/filter": 833,
	"./products/partners-tipoproducto/filter.js": 833,
	"./products/partners-tipoproducto/record": 836,
	"./products/partners-tipoproducto/record.js": 836,
	"./products/partners-tipoproducto/recordTable": 1784,
	"./products/partners-tipoproducto/recordTable.js": 1784,
	"./products/partners-tipoproducto/table": 834,
	"./products/partners-tipoproducto/table.js": 834,
	"./products/partners/filter": 816,
	"./products/partners/filter.js": 816,
	"./products/partners/table": 817,
	"./products/partners/table.js": 817,
	"./products/products/detailsProducts": 1038,
	"./products/products/detailsProducts.js": 1038,
	"./products/products/filterProducts": 858,
	"./products/products/filterProducts.js": 858,
	"./products/products/recordProducts": 1039,
	"./products/products/recordProducts.js": 1039,
	"./products/products/recordTableProducts": 860,
	"./products/products/recordTableProducts.js": 860,
	"./products/products/tableProducts": 859,
	"./products/products/tableProducts.js": 859,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 861,
	"./products/providers/filterProviders.js": 861,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 325,
	"./products/providers/recordTableProviders.js": 325,
	"./products/providers/tableProviders": 862,
	"./products/providers/tableProviders.js": 862,
	"./products/subProviders/filter": 863,
	"./products/subProviders/filter.js": 863,
	"./products/subProviders/table": 864,
	"./products/subProviders/table.js": 864,
	"./products/tags/detailsTags": 1040,
	"./products/tags/detailsTags.js": 1040,
	"./products/tags/filterTags": 865,
	"./products/tags/filterTags.js": 865,
	"./products/tags/recordTableTags": 866,
	"./products/tags/recordTableTags.js": 866,
	"./products/tags/recordTags": 1041,
	"./products/tags/recordTags.js": 1041,
	"./products/tags/tableTags": 867,
	"./products/tags/tableTags.js": 867,
	"./profile": 1785,
	"./profile.js": 1785,
	"./profileOptions": 1786,
	"./profileOptions.js": 1786,
	"./profileOptions2": 1787,
	"./profileOptions2.js": 1787,
	"./profileOptionsOld": 1788,
	"./profileOptionsOld.js": 1788,
	"./promotionalCasinoCampaings": 1789,
	"./promotionalCasinoCampaings.js": 1789,
	"./promotionalCodes": 1790,
	"./promotionalCodes.js": 1790,
	"./promotionalSportbookCampaings": 1791,
	"./promotionalSportbookCampaings.js": 1791,
	"./providers": 1792,
	"./providers.js": 1792,
	"./qualifying": 1793,
	"./qualifying.js": 1793,
	"./quotaRetraction": 1794,
	"./quotaRetraction.js": 1794,
	"./quotaRetractionReport": 1795,
	"./quotaRetractionReport.js": 1795,
	"./recargarCredito": 1796,
	"./recargarCredito.js": 1796,
	"./recargarCreditoAgente": 1797,
	"./recargarCreditoAgente.js": 1797,
	"./referralsAwardsReport": 1798,
	"./referralsAwardsReport.js": 1798,
	"./referralsReport": 1799,
	"./referralsReport.js": 1799,
	"./registerFast": 1800,
	"./registerFast.js": 1800,
	"./registeredDocument": 1801,
	"./registeredDocument.js": 1801,
	"./registeredDocuments": 1802,
	"./registeredDocuments.js": 1802,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 438,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 438,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 439,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 439,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 440,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 440,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 441,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 441,
	"./regulations/futureEvents/filterFutureEventsReports": 522,
	"./regulations/futureEvents/filterFutureEventsReports.js": 522,
	"./regulations/futureEvents/tableFutureEventsReports": 523,
	"./regulations/futureEvents/tableFutureEventsReports.js": 523,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 524,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 524,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 525,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 525,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 526,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 526,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 527,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 527,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 553,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 553,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 554,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 554,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 555,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 555,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 556,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 556,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 557,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 557,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 558,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 558,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 559,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 559,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 560,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 560,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 682,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 682,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 683,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 683,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 684,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 684,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 685,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 685,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 837,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 837,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 838,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 838,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 839,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 839,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 840,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 840,
	"./regulations/playerAccount/filterPlayerAccountReports": 841,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 841,
	"./regulations/playerAccount/tablePlayerAccountReports": 842,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 842,
	"./regulations/playerAccount2/filterPlayerAccountReports": 843,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 843,
	"./regulations/playerAccount2/tablePlayerAccountReports": 844,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 844,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 892,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 892,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 893,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 893,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 894,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 894,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 895,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 895,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 896,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 896,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 897,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 897,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 898,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 898,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 899,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 899,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 900,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 900,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 901,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 901,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 902,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 902,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 903,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 903,
	"./relationUserAggregator": 1803,
	"./relationUserAggregator.js": 1803,
	"./reportHash": 1804,
	"./reportHash.js": 1804,
	"./reportMarketing": 1805,
	"./reportMarketing.js": 1805,
	"./reports/affiliatesBetShop/filter": 209,
	"./reports/affiliatesBetShop/filter.js": 209,
	"./reports/affiliatesBetShop/table": 210,
	"./reports/affiliatesBetShop/table.js": 210,
	"./reports/assignmentQuota/filter": 294,
	"./reports/assignmentQuota/filter.js": 294,
	"./reports/assignmentQuota/table": 295,
	"./reports/assignmentQuota/table.js": 295,
	"./reports/assignmentQuotaMade/filter": 292,
	"./reports/assignmentQuotaMade/filter.js": 292,
	"./reports/assignmentQuotaMade/table": 293,
	"./reports/assignmentQuotaMade/table.js": 293,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 298,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 299,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 297,
	"./reports/balanceAdjustments/filter": 300,
	"./reports/balanceAdjustments/filter.js": 300,
	"./reports/balanceAdjustments/table": 301,
	"./reports/balanceAdjustments/table.js": 301,
	"./reports/balanceHistory/filter": 302,
	"./reports/balanceHistory/filter.js": 302,
	"./reports/balanceHistory/table": 303,
	"./reports/balanceHistory/table.js": 303,
	"./reports/balanceHistory2/filter": 1806,
	"./reports/balanceHistory2/filter.js": 1806,
	"./reports/balanceHistory2/filter2": 304,
	"./reports/balanceHistory2/filter2.js": 304,
	"./reports/balanceHistory2/table": 1807,
	"./reports/balanceHistory2/table.js": 1807,
	"./reports/balanceHistory2/table2": 305,
	"./reports/balanceHistory2/table2.js": 305,
	"./reports/balanceHistoryBetShop/filter": 308,
	"./reports/balanceHistoryBetShop/filter.js": 308,
	"./reports/balanceHistoryBetShop/table": 309,
	"./reports/balanceHistoryBetShop/table.js": 309,
	"./reports/balanceHistoryBetShop2/filter": 1808,
	"./reports/balanceHistoryBetShop2/filter.js": 1808,
	"./reports/balanceHistoryBetShop2/filter2": 310,
	"./reports/balanceHistoryBetShop2/filter2.js": 310,
	"./reports/balanceHistoryBetShop2/table": 1809,
	"./reports/balanceHistoryBetShop2/table.js": 1809,
	"./reports/balanceHistoryBetShop2/table2": 311,
	"./reports/balanceHistoryBetShop2/table2.js": 311,
	"./reports/balanceHistoryForAdminUser/filter": 306,
	"./reports/balanceHistoryForAdminUser/filter.js": 306,
	"./reports/balanceHistoryForAdminUser/table": 307,
	"./reports/balanceHistoryForAdminUser/table.js": 307,
	"./reports/balanceHistoryForAgent/filter": 312,
	"./reports/balanceHistoryForAgent/filter.js": 312,
	"./reports/balanceHistoryForAgent/table": 313,
	"./reports/balanceHistoryForAgent/table.js": 313,
	"./reports/balanceHistoryForBetShop/filter": 314,
	"./reports/balanceHistoryForBetShop/filter.js": 314,
	"./reports/balanceHistoryForBetShop/table": 315,
	"./reports/balanceHistoryForBetShop/table.js": 315,
	"./reports/balanceHistoryMachine/filter": 316,
	"./reports/balanceHistoryMachine/filter.js": 316,
	"./reports/balanceHistoryMachine/table": 317,
	"./reports/balanceHistoryMachine/table.js": 317,
	"./reports/balanceUsers/filter": 318,
	"./reports/balanceUsers/filter.js": 318,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 320,
	"./reports/balanceUsers/resume.js": 320,
	"./reports/balanceUsers/table": 319,
	"./reports/balanceUsers/table.js": 319,
	"./reports/betsReport/detailsReport": 1810,
	"./reports/betsReport/detailsReport.js": 1810,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1811,
	"./reports/betsReportBetShop/detailsReport.js": 1811,
	"./reports/betsReportBetShop/filterReport": 374,
	"./reports/betsReportBetShop/filterReport.js": 374,
	"./reports/betsReportBetShop/recordReport": 377,
	"./reports/betsReportBetShop/recordReport.js": 377,
	"./reports/betsReportBetShop/recordTableReport": 1812,
	"./reports/betsReportBetShop/recordTableReport.js": 1812,
	"./reports/betsReportBetShop/recordTableTransReport": 1813,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1813,
	"./reports/betsReportBetShop/recordTransReport": 376,
	"./reports/betsReportBetShop/recordTransReport.js": 376,
	"./reports/betsReportBetShop/tableReport": 375,
	"./reports/betsReportBetShop/tableReport.js": 375,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 382,
	"./reports/bonusReport/filterBonusReport.js": 382,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 383,
	"./reports/bonusReport/tableBonusReport.js": 383,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 384,
	"./reports/bonusReport2/filterBonusReport.js": 384,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1814,
	"./reports/bonusReport2/recordTableBonusReport.js": 1814,
	"./reports/bonusReport2/tableBonusReport": 385,
	"./reports/bonusReport2/tableBonusReport.js": 385,
	"./reports/bonusReports2/filter": 386,
	"./reports/bonusReports2/filter.js": 386,
	"./reports/bonusReports2/table": 387,
	"./reports/bonusReports2/table.js": 387,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 418,
	"./reports/casinoReport/filterCasinoReport.js": 418,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 419,
	"./reports/casinoReport/tableCasinoReport.js": 419,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1815,
	"./reports/casinoReport2/filterCasinoReport.js": 1815,
	"./reports/casinoReport2/filterCasinoReport2": 420,
	"./reports/casinoReport2/filterCasinoReport2.js": 420,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1816,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1816,
	"./reports/casinoReport2/tableCasinoReport": 1817,
	"./reports/casinoReport2/tableCasinoReport.js": 1817,
	"./reports/casinoReport2/tableCasinoReport2": 421,
	"./reports/casinoReport2/tableCasinoReport2.js": 421,
	"./reports/comissions_report/filter": 428,
	"./reports/comissions_report/filter.js": 428,
	"./reports/comissions_report/table": 429,
	"./reports/comissions_report/table.js": 429,
	"./reports/comissions_report2/filter": 430,
	"./reports/comissions_report2/filter.js": 430,
	"./reports/comissions_report2/table": 431,
	"./reports/comissions_report2/table.js": 431,
	"./reports/commisionsPay/filter": 432,
	"./reports/commisionsPay/filter.js": 432,
	"./reports/commisionsPay/table": 433,
	"./reports/commisionsPay/table.js": 433,
	"./reports/coupons_report/details": 1818,
	"./reports/coupons_report/details.js": 1818,
	"./reports/coupons_report/filter": 447,
	"./reports/coupons_report/filter.js": 447,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1819,
	"./reports/coupons_report/recordReports.js": 1819,
	"./reports/coupons_report/table": 448,
	"./reports/coupons_report/table.js": 448,
	"./reports/customReport/filter": 453,
	"./reports/customReport/filter.js": 453,
	"./reports/customReport/table": 454,
	"./reports/customReport/table.js": 454,
	"./reports/depositReport2/filter": 499,
	"./reports/depositReport2/filter.js": 499,
	"./reports/depositReport2/table": 500,
	"./reports/depositReport2/table.js": 500,
	"./reports/depositReportFranchise/filterDepositReportFranchise": 505,
	"./reports/depositReportFranchise/filterDepositReportFranchise.js": 505,
	"./reports/depositReportFranchise/tableDepositReportFranchise": 506,
	"./reports/depositReportFranchise/tableDepositReportFranchise.js": 506,
	"./reports/deposit_report/detailsDepositReports": 1026,
	"./reports/deposit_report/detailsDepositReports.js": 1026,
	"./reports/deposit_report/filterDepositReports": 497,
	"./reports/deposit_report/filterDepositReports.js": 497,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 498,
	"./reports/deposit_report/tableDepositReports.js": 498,
	"./reports/deposit_report_3/detailsDepositReports": 1027,
	"./reports/deposit_report_3/detailsDepositReports.js": 1027,
	"./reports/deposit_report_3/filterDepositReports": 501,
	"./reports/deposit_report_3/filterDepositReports.js": 501,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1820,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1820,
	"./reports/deposit_report_3/tableDepositReports": 502,
	"./reports/deposit_report_3/tableDepositReports.js": 502,
	"./reports/deposit_report_betshop/detailsDepositReports": 1028,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1028,
	"./reports/deposit_report_betshop/filterDepositReports": 503,
	"./reports/deposit_report_betshop/filterDepositReports.js": 503,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1821,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1821,
	"./reports/deposit_report_betshop/tableDepositReports": 504,
	"./reports/deposit_report_betshop/tableDepositReports.js": 504,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 514,
	"./reports/emailsReport/filterEmailsReport.js": 514,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1822,
	"./reports/emailsReport/recordTableEmailsReport.js": 1822,
	"./reports/emailsReport/tableEmailsReport": 515,
	"./reports/emailsReport/tableEmailsReport.js": 515,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 910,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 910,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 911,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 911,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 912,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 912,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 913,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 913,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 914,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1823,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1823,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 915,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 915,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 916,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 916,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1824,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1824,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1825,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1825,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 917,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 917,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 918,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 918,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 919,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 919,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 920,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 920,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1826,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1826,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 921,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 921,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 530,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 530,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 528,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 528,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 531,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 531,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 532,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 532,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 529,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 529,
	"./reports/historyMovement/filter": 533,
	"./reports/historyMovement/filter.js": 533,
	"./reports/historyMovement/table": 534,
	"./reports/historyMovement/table.js": 534,
	"./reports/historyMovementBetShop/filter": 535,
	"./reports/historyMovementBetShop/filter.js": 535,
	"./reports/historyMovementBetShop/table": 536,
	"./reports/historyMovementBetShop/table.js": 536,
	"./reports/historyPoints/filter": 537,
	"./reports/historyPoints/filter.js": 537,
	"./reports/historyPoints/table": 538,
	"./reports/historyPoints/table.js": 538,
	"./reports/informeCasino/detailsInformeCasino": 541,
	"./reports/informeCasino/detailsInformeCasino.js": 541,
	"./reports/informeCasino/filterInformeCasino": 539,
	"./reports/informeCasino/filterInformeCasino.js": 539,
	"./reports/informeCasino/recordInformeCasino": 542,
	"./reports/informeCasino/recordInformeCasino.js": 542,
	"./reports/informeCasino/recordTableInformeCasino": 1827,
	"./reports/informeCasino/recordTableInformeCasino.js": 1827,
	"./reports/informeCasino/tableInformeCasino": 540,
	"./reports/informeCasino/tableInformeCasino.js": 540,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome": 437,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome.js": 437,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome": 436,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome.js": 436,
	"./reports/informeGerencial/detailsInformeGerencial": 1828,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1828,
	"./reports/informeGerencial/filterInformeGerencial": 543,
	"./reports/informeGerencial/filterInformeGerencial.js": 543,
	"./reports/informeGerencial/recordInformeGerencial": 1829,
	"./reports/informeGerencial/recordInformeGerencial.js": 1829,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 544,
	"./reports/informeGerencial/tableInformeGerencial.js": 544,
	"./reports/informeGerencial2/detailsInformeGerencial": 1830,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1830,
	"./reports/informeGerencial2/filterInformeGerencial": 1831,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1831,
	"./reports/informeGerencial2/filterInformeGerencial2": 545,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 545,
	"./reports/informeGerencial2/recordInformeGerencial": 1832,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1832,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1833,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1833,
	"./reports/informeGerencial2/tableInformeGerencial": 1834,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1834,
	"./reports/informeGerencial2/tableInformeGerencial2": 546,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 546,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1835,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1835,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1836,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1836,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 547,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 547,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1837,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1837,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1838,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1838,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1839,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1839,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 548,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 548,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1840,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1840,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1841,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1841,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 549,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 549,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1842,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1842,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1843,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1843,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1844,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1844,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 550,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 550,
	"./reports/jackpotInternationalReport/filter": 551,
	"./reports/jackpotInternationalReport/filter.js": 551,
	"./reports/jackpotInternationalReport/table": 552,
	"./reports/jackpotInternationalReport/table.js": 552,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 561,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 561,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1845,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1845,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1846,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1846,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 562,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 562,
	"./reports/landingReport/detailsLandingReport": 565,
	"./reports/landingReport/detailsLandingReport.js": 565,
	"./reports/landingReport/filterLandingReport": 563,
	"./reports/landingReport/filterLandingReport.js": 563,
	"./reports/landingReport/recordLandingReport": 566,
	"./reports/landingReport/recordLandingReport.js": 566,
	"./reports/landingReport/recordTableLandingReport": 1847,
	"./reports/landingReport/recordTableLandingReport.js": 1847,
	"./reports/landingReport/tableLandingReport": 564,
	"./reports/landingReport/tableLandingReport.js": 564,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 567,
	"./reports/landingReport2/filterLandingReport.js": 567,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1848,
	"./reports/landingReport2/recordTableLandingReport.js": 1848,
	"./reports/landingReport2/tableLandingReport": 568,
	"./reports/landingReport2/tableLandingReport.js": 568,
	"./reports/limitationsReport/filterDepositReports": 585,
	"./reports/limitationsReport/filterDepositReports.js": 585,
	"./reports/limitationsReport/tableDepositReports": 586,
	"./reports/limitationsReport/tableDepositReports.js": 586,
	"./reports/logsUser/filter": 589,
	"./reports/logsUser/filter.js": 589,
	"./reports/logsUser/table": 590,
	"./reports/logsUser/table.js": 590,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 591,
	"./reports/loteryReport/filterLoteryReport.js": 591,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1849,
	"./reports/loteryReport/recordTableLoteryReport.js": 1849,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 592,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 592,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 593,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 593,
	"./reports/my_comissions_report/filter": 676,
	"./reports/my_comissions_report/filter.js": 676,
	"./reports/my_comissions_report/table": 677,
	"./reports/my_comissions_report/table.js": 677,
	"./reports/notesUser/filter": 678,
	"./reports/notesUser/filter.js": 678,
	"./reports/notesUser/table": 679,
	"./reports/notesUser/table.js": 679,
	"./reports/operatorResponsibility/filter": 680,
	"./reports/operatorResponsibility/filter.js": 680,
	"./reports/operatorResponsibility/table": 681,
	"./reports/operatorResponsibility/table.js": 681,
	"./reports/partners-categories/filter": 818,
	"./reports/partners-categories/filter.js": 818,
	"./reports/partners-categories/table": 819,
	"./reports/partners-categories/table.js": 819,
	"./reports/playersReport/detailsPlayersReport": 847,
	"./reports/playersReport/detailsPlayersReport.js": 847,
	"./reports/playersReport/filterPlayersReport": 845,
	"./reports/playersReport/filterPlayersReport.js": 845,
	"./reports/playersReport/recordPlayersReport": 848,
	"./reports/playersReport/recordPlayersReport.js": 848,
	"./reports/playersReport/recordTablePlayersReport": 849,
	"./reports/playersReport/recordTablePlayersReport.js": 849,
	"./reports/playersReport/tablePlayersReport": 846,
	"./reports/playersReport/tablePlayersReport.js": 846,
	"./reports/pointSettings/filter": 850,
	"./reports/pointSettings/filter.js": 850,
	"./reports/pointSettings/table": 851,
	"./reports/pointSettings/table.js": 851,
	"./reports/pointsUsers/filter": 852,
	"./reports/pointsUsers/filter.js": 852,
	"./reports/pointsUsers/table": 853,
	"./reports/pointsUsers/table.js": 853,
	"./reports/pokerReport/filterCasinoReport": 854,
	"./reports/pokerReport/filterCasinoReport.js": 854,
	"./reports/pokerReport/tableCasinoReport": 855,
	"./reports/pokerReport/tableCasinoReport.js": 855,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1850,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1850,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 686,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 686,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1851,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1851,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 922,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 922,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 687,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 687,
	"./reports/prizesLoyalty/filter": 856,
	"./reports/prizesLoyalty/filter.js": 856,
	"./reports/prizesLoyalty/table": 857,
	"./reports/prizesLoyalty/table.js": 857,
	"./reports/promotionalCasinoCampaings/filter": 873,
	"./reports/promotionalCasinoCampaings/filter.js": 873,
	"./reports/promotionalCasinoCampaings/table": 874,
	"./reports/promotionalCasinoCampaings/table.js": 874,
	"./reports/promotionalCodes/filter": 875,
	"./reports/promotionalCodes/filter.js": 875,
	"./reports/promotionalCodes/table": 876,
	"./reports/promotionalCodes/table.js": 876,
	"./reports/promotionalSpoortbookCampaings/filter": 877,
	"./reports/promotionalSpoortbookCampaings/filter.js": 877,
	"./reports/promotionalSpoortbookCampaings/table": 878,
	"./reports/promotionalSpoortbookCampaings/table.js": 878,
	"./reports/quotaRetraction/filter": 881,
	"./reports/quotaRetraction/filter.js": 881,
	"./reports/quotaRetraction/table": 882,
	"./reports/quotaRetraction/table.js": 882,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 883,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 883,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1852,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1852,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1853,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1853,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 884,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 884,
	"./reports/referralsReport/filterReferralsReports": 885,
	"./reports/referralsReport/filterReferralsReports.js": 885,
	"./reports/referralsReport/recordReferralsReports": 1854,
	"./reports/referralsReport/recordReferralsReports.js": 1854,
	"./reports/referralsReport/recordTableReferralsReports": 1855,
	"./reports/referralsReport/recordTableReferralsReports.js": 1855,
	"./reports/referralsReport/tableReferralsReports": 886,
	"./reports/referralsReport/tableReferralsReports.js": 886,
	"./reports/registeredDocuments/filter": 887,
	"./reports/registeredDocuments/filter.js": 887,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 889,
	"./reports/registeredDocuments/recordTable.js": 889,
	"./reports/registeredDocuments/table": 888,
	"./reports/registeredDocuments/table.js": 888,
	"./reports/relationUserAggregator/filter": 904,
	"./reports/relationUserAggregator/filter.js": 904,
	"./reports/relationUserAggregator/table": 905,
	"./reports/relationUserAggregator/table.js": 905,
	"./reports/reportHash/filter": 906,
	"./reports/reportHash/filter.js": 906,
	"./reports/reportHash/table": 907,
	"./reports/reportHash/table.js": 907,
	"./reports/reportMarketing/filter": 908,
	"./reports/reportMarketing/filter.js": 908,
	"./reports/reportMarketing/table": 909,
	"./reports/reportMarketing/table.js": 909,
	"./reports/rouletteReport/filter": 923,
	"./reports/rouletteReport/filter.js": 923,
	"./reports/rouletteReport/table": 924,
	"./reports/rouletteReport/table.js": 924,
	"./reports/sessionsReport/detailsSessionsReport": 925,
	"./reports/sessionsReport/detailsSessionsReport.js": 925,
	"./reports/sessionsReport/filterSessionsReport": 926,
	"./reports/sessionsReport/filterSessionsReport.js": 926,
	"./reports/sessionsReport/recordSessionsReport": 1042,
	"./reports/sessionsReport/recordSessionsReport.js": 1042,
	"./reports/sessionsReport/recordTableSessionsReport": 1043,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1043,
	"./reports/sessionsReport/tableSessionsReport": 927,
	"./reports/sessionsReport/tableSessionsReport.js": 927,
	"./reports/sessionsReport2/filter": 928,
	"./reports/sessionsReport2/filter.js": 928,
	"./reports/sessionsReport2/table": 929,
	"./reports/sessionsReport2/table.js": 929,
	"./reports/sportsPoolReport/filterReport": 930,
	"./reports/sportsPoolReport/filterReport.js": 930,
	"./reports/sportsPoolReport/tableReport": 931,
	"./reports/sportsPoolReport/tableReport.js": 931,
	"./reports/sportsTransactions/filter": 932,
	"./reports/sportsTransactions/filter.js": 932,
	"./reports/sportsTransactions/table": 933,
	"./reports/sportsTransactions/table.js": 933,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 934,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 934,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 935,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 935,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 936,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 936,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1856,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1856,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 937,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 937,
	"./reports/taxPaymentsReport/filter": 938,
	"./reports/taxPaymentsReport/filter.js": 938,
	"./reports/taxPaymentsReport/table": 939,
	"./reports/taxPaymentsReport/table.js": 939,
	"./reports/taxableEarnings/filter": 940,
	"./reports/taxableEarnings/filter.js": 940,
	"./reports/taxableEarnings/table": 941,
	"./reports/taxableEarnings/table.js": 941,
	"./reports/transactionReport/filter": 942,
	"./reports/transactionReport/filter.js": 942,
	"./reports/transactionReport/table": 943,
	"./reports/transactionReport/table.js": 943,
	"./reports/transfersReport/filter": 944,
	"./reports/transfersReport/filter.js": 944,
	"./reports/transfersReport/table": 945,
	"./reports/transfersReport/table.js": 945,
	"./reports/userAffiliatesAgent/filter": 946,
	"./reports/userAffiliatesAgent/filter.js": 946,
	"./reports/userAffiliatesAgent/table": 947,
	"./reports/userAffiliatesAgent/table.js": 947,
	"./reports/userAffiliatesBetShop/filter": 948,
	"./reports/userAffiliatesBetShop/filter.js": 948,
	"./reports/userAffiliatesBetShop/table": 949,
	"./reports/userAffiliatesBetShop/table.js": 949,
	"./reports/usuarioOnlineResumido/filter": 950,
	"./reports/usuarioOnlineResumido/filter.js": 950,
	"./reports/usuarioOnlineResumido/table": 951,
	"./reports/usuarioOnlineResumido/table.js": 951,
	"./reports/withdrawalReport2/filter": 952,
	"./reports/withdrawalReport2/filter.js": 952,
	"./reports/withdrawalReport2/table": 953,
	"./reports/withdrawalReport2/table.js": 953,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 954,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 954,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 955,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 955,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1857,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1857,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 956,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 956,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 957,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 957,
	"./reports/withdrawalRequestsComissions/filter": 958,
	"./reports/withdrawalRequestsComissions/filter.js": 958,
	"./reports/withdrawalRequestsComissions/table": 959,
	"./reports/withdrawalRequestsComissions/table.js": 959,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 960,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 960,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 961,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 961,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 962,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 962,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1858,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1858,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 963,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 963,
	"./reprintCheck": 1859,
	"./reprintCheck.js": 1859,
	"./requests/registration-requests/filter": 964,
	"./requests/registration-requests/filter.js": 964,
	"./requests/registration-requests/generateRequests": 965,
	"./requests/registration-requests/generateRequests.js": 965,
	"./requests/registration-requests/recordTableResponts": 966,
	"./requests/registration-requests/recordTableResponts.js": 966,
	"./requests/registration-requests/table": 968,
	"./requests/registration-requests/table.js": 968,
	"./requests/registration-requests/tableResponts": 967,
	"./requests/registration-requests/tableResponts.js": 967,
	"./requests/registrationRequests": 1860,
	"./requests/registrationRequests.js": 1860,
	"./resources-locale_es.json": 1962,
	"./restrictUser": 1861,
	"./restrictUser.js": 1861,
	"./reversionReload": 1862,
	"./reversionReload.js": 1862,
	"./rouletteReport": 1863,
	"./rouletteReport.js": 1863,
	"./security/adminuser/addAdminUser": 1864,
	"./security/adminuser/addAdminUser.js": 1864,
	"./security/adminuser/configuration/changePassword": 1865,
	"./security/adminuser/configuration/changePassword.js": 1865,
	"./security/adminuser/configuration/changePassword/changePasswordView": 969,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 969,
	"./security/adminuser/configuration/generateToken": 1866,
	"./security/adminuser/configuration/generateToken.js": 1866,
	"./security/adminuser/configuration/generateToken/filter": 970,
	"./security/adminuser/configuration/generateToken/filter.js": 970,
	"./security/adminuser/configuration/generateToken/table": 971,
	"./security/adminuser/configuration/generateToken/table.js": 971,
	"./security/adminuser/configuration/qrgoogle": 1867,
	"./security/adminuser/configuration/qrgoogle.js": 1867,
	"./security/adminuser/configuration/securityChanges": 1868,
	"./security/adminuser/configuration/securityChanges.js": 1868,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1869,
	"./security/adminuser/configurationAdminUser.js": 1869,
	"./security/adminuser/detailsAdminUser": 1870,
	"./security/adminuser/detailsAdminUser.js": 1870,
	"./security/adminuser/filterAdminUser": 207,
	"./security/adminuser/filterAdminUser.js": 207,
	"./security/adminuser/informationAdminUser": 1871,
	"./security/adminuser/informationAdminUser.js": 1871,
	"./security/adminuser/recordAdminUser": 1872,
	"./security/adminuser/recordAdminUser.js": 1872,
	"./security/adminuser/recordTableAdminUser": 972,
	"./security/adminuser/recordTableAdminUser.js": 972,
	"./security/adminuser/reports/logsUser": 1873,
	"./security/adminuser/reports/logsUser.js": 1873,
	"./security/adminuser/reports/logsUser/filter": 973,
	"./security/adminuser/reports/logsUser/filter.js": 973,
	"./security/adminuser/reports/logsUser/table": 974,
	"./security/adminuser/reports/logsUser/table.js": 974,
	"./security/adminuser/reportsAdminUser": 1874,
	"./security/adminuser/reportsAdminUser.js": 1874,
	"./security/adminuser/tableAdminUser": 208,
	"./security/adminuser/tableAdminUser.js": 208,
	"./security/approvalLogs/filter": 286,
	"./security/approvalLogs/filter.js": 286,
	"./security/approvalLogs/table": 287,
	"./security/approvalLogs/table.js": 287,
	"./security/approvalLogs2/filter": 288,
	"./security/approvalLogs2/filter.js": 288,
	"./security/approvalLogs2/table": 289,
	"./security/approvalLogs2/table.js": 289,
	"./security/approvalLogsBetShop/filter": 290,
	"./security/approvalLogsBetShop/filter.js": 290,
	"./security/approvalLogsBetShop/table": 291,
	"./security/approvalLogsBetShop/table.js": 291,
	"./security/contingencia/detailsContingencia": 1875,
	"./security/contingencia/detailsContingencia.js": 1875,
	"./security/contingencia/filterContingencia": 442,
	"./security/contingencia/filterContingencia.js": 442,
	"./security/contingencia/recordContingencia": 1876,
	"./security/contingencia/recordContingencia.js": 1876,
	"./security/contingencia/recordTableContingencia": 975,
	"./security/contingencia/recordTableContingencia.js": 975,
	"./security/contingencia/tableContingencia": 443,
	"./security/contingencia/tableContingencia.js": 443,
	"./security/menu/filter": 666,
	"./security/menu/filter.js": 666,
	"./security/menu/table": 667,
	"./security/menu/table.js": 667,
	"./security/perfil/detailsPerfil": 870,
	"./security/perfil/detailsPerfil.js": 870,
	"./security/perfil/filterPerfil": 868,
	"./security/perfil/filterPerfil.js": 868,
	"./security/perfil/recordPerfil": 871,
	"./security/perfil/recordPerfil.js": 871,
	"./security/perfil/recordTablePerfil": 872,
	"./security/perfil/recordTablePerfil.js": 872,
	"./security/perfil/tablePerfil": 869,
	"./security/perfil/tablePerfil.js": 869,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1877,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1877,
	"./security/perfilopciones2/filterPerfilOpciones": 1878,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1878,
	"./security/perfilopciones2/recordPerfilOpciones": 1879,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1879,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1880,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1880,
	"./security/perfilopciones2/tablePerfilOpciones": 1881,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1881,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1882,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1882,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1883,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1883,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1884,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1884,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1885,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1885,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1886,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1886,
	"./security/submenu/detailsSubMenu": 976,
	"./security/submenu/detailsSubMenu.js": 976,
	"./security/submenu/filterSubMenu": 977,
	"./security/submenu/filterSubMenu.js": 977,
	"./security/submenu/recordSubMenu": 978,
	"./security/submenu/recordSubMenu.js": 978,
	"./security/submenu/recordTableSubMenu": 979,
	"./security/submenu/recordTableSubMenu.js": 979,
	"./security/submenu/tableSubMenu": 980,
	"./security/submenu/tableSubMenu.js": 980,
	"./security/totalContingencies/table": 981,
	"./security/totalContingencies/table.js": 981,
	"./security/userSitebuilder/filter": 982,
	"./security/userSitebuilder/filter.js": 982,
	"./security/userSitebuilder/information": 1887,
	"./security/userSitebuilder/information.js": 1887,
	"./security/userSitebuilder/table": 983,
	"./security/userSitebuilder/table.js": 983,
	"./security/userVerification2/filter": 984,
	"./security/userVerification2/filter.js": 984,
	"./security/userVerification2/information": 1888,
	"./security/userVerification2/information.js": 1888,
	"./security/userVerification2/table": 985,
	"./security/userVerification2/table.js": 985,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1889,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1889,
	"./security/usuarioperfil/filterUsuarioPerfil": 986,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 986,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 987,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 987,
	"./security/usuarioperfil/recordUsuarioPerfil": 1890,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1890,
	"./security/usuarioperfil/tableUsuarioPerfil": 988,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 988,
	"./security/usuariosbloqueados/add": 1891,
	"./security/usuariosbloqueados/add.js": 1891,
	"./security/usuariosbloqueados/filter": 989,
	"./security/usuariosbloqueados/filter.js": 989,
	"./security/usuariosbloqueados/table": 990,
	"./security/usuariosbloqueados/table.js": 990,
	"./security/wallets/filter": 991,
	"./security/wallets/filter.js": 991,
	"./security/wallets/table": 992,
	"./security/wallets/table.js": 992,
	"./sessionsReport": 1892,
	"./sessionsReport.js": 1892,
	"./sessionsReport2": 1893,
	"./sessionsReport2.js": 1893,
	"./settings": 1894,
	"./settings.js": 1894,
	"./significantEventsAndAlterations": 1895,
	"./significantEventsAndAlterations.js": 1895,
	"./significantEventsAndAlterations2": 1896,
	"./significantEventsAndAlterations2.js": 1896,
	"./sportsPoolReport": 1897,
	"./sportsPoolReport.js": 1897,
	"./sportsTransactions": 1898,
	"./sportsTransactions.js": 1898,
	"./subMenu": 1899,
	"./subMenu.js": 1899,
	"./subProviders": 1900,
	"./subProviders.js": 1900,
	"./summaryBetsReport": 1901,
	"./summaryBetsReport.js": 1901,
	"./summaryCashFlow": 1902,
	"./summaryCashFlow.js": 1902,
	"./summaryCashFlow2": 1903,
	"./summaryCashFlow2.js": 1903,
	"./summaryCashFlowMachine": 1904,
	"./summaryCashFlowMachine.js": 1904,
	"./tags": 1905,
	"./tags.js": 1905,
	"./taxPaymentsReport": 1906,
	"./taxPaymentsReport.js": 1906,
	"./taxableEarnings": 1907,
	"./taxableEarnings.js": 1907,
	"./teacher/concessionaire/filterConcessionaire": 518,
	"./teacher/concessionaire/filterConcessionaire.js": 518,
	"./teacher/concessionaire/tableConcessionaire": 519,
	"./teacher/concessionaire/tableConcessionaire.js": 519,
	"./teacher/qualifying/filterQualifying": 879,
	"./teacher/qualifying/filterQualifying.js": 879,
	"./teacher/qualifying/tableQualifying": 880,
	"./teacher/qualifying/tableQualifying.js": 880,
	"./teacher/registered-documents/filterRegisteredDocuments": 890,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 890,
	"./teacher/registered-documents/tableRegisteredDocuments": 891,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 891,
	"./termsAndConditions": 1908,
	"./termsAndConditions.js": 1908,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 444,
	"./tools/countries/filter.js": 444,
	"./tools/countries/table": 445,
	"./tools/countries/table.js": 445,
	"./tools/currencyManagement/currencyFilters": 171,
	"./tools/currencyManagement/currencyFilters.js": 171,
	"./tools/currencyManagement/currencyTable": 172,
	"./tools/currencyManagement/currencyTable.js": 172,
	"./tools/translationManager": 1909,
	"./tools/translationManager.js": 1909,
	"./tools/translationManager/filter": 993,
	"./tools/translationManager/filter.js": 993,
	"./tools/translationManager/table": 994,
	"./tools/translationManager/table.js": 994,
	"./tools/uploadImage": 1910,
	"./tools/uploadImage.js": 1910,
	"./top": 1911,
	"./top.js": 1911,
	"./totalContingencies": 1912,
	"./totalContingencies.js": 1912,
	"./transactionReport": 1913,
	"./transactionReport.js": 1913,
	"./transactions": 1914,
	"./transactions.js": 1914,
	"./transactionsByPlayer": 1915,
	"./transactionsByPlayer.js": 1915,
	"./transactionsByPlayerDeposit": 1916,
	"./transactionsByPlayerDeposit.js": 1916,
	"./transactionsByPlayerFirstLevel": 1917,
	"./transactionsByPlayerFirstLevel.js": 1917,
	"./transactionsByPlayerSecondLevel": 1918,
	"./transactionsByPlayerSecondLevel.js": 1918,
	"./trasnfersReport": 1919,
	"./trasnfersReport.js": 1919,
	"./tutorials": 1920,
	"./tutorials.js": 1920,
	"./userAffiliatesAgent": 1921,
	"./userAffiliatesAgent.js": 1921,
	"./userAffiliatesBetShop": 1922,
	"./userAffiliatesBetShop.js": 1922,
	"./userManagement": 1923,
	"./userManagement.js": 1923,
	"./userManagement/userManagement/detailsUserManagement": 997,
	"./userManagement/userManagement/detailsUserManagement.js": 997,
	"./userManagement/userManagement/filterUserManagement": 995,
	"./userManagement/userManagement/filterUserManagement.js": 995,
	"./userManagement/userManagement/recordTableUserManagement": 999,
	"./userManagement/userManagement/recordTableUserManagement.js": 999,
	"./userManagement/userManagement/recordUserManagement": 998,
	"./userManagement/userManagement/recordUserManagement.js": 998,
	"./userManagement/userManagement/tableUserManagement": 996,
	"./userManagement/userManagement/tableUserManagement.js": 996,
	"./userProfile": 1924,
	"./userProfile.js": 1924,
	"./usersSitebuilder": 1925,
	"./usersSitebuilder.js": 1925,
	"./usersVerification": 1926,
	"./usersVerification.js": 1926,
	"./usersVerification/information": 1000,
	"./usersVerification/information.js": 1000,
	"./usersVerification2": 1927,
	"./usersVerification2.js": 1927,
	"./usersVerificationManagement": 1928,
	"./usersVerificationManagement.js": 1928,
	"./usuarioOnlineResumido": 1929,
	"./usuarioOnlineResumido.js": 1929,
	"./usuariosbloqueados": 1930,
	"./usuariosbloqueados.js": 1930,
	"./verifyAccount": 1931,
	"./verifyAccount.js": 1931,
	"./verifyAccountAgent": 1932,
	"./verifyAccountAgent.js": 1932,
	"./verifyAccountJumio": 1933,
	"./verifyAccountJumio.js": 1933,
	"./wallets": 1934,
	"./wallets.js": 1934,
	"./watchListReport": 1935,
	"./watchListReport.js": 1935,
	"./watchListReport/filterReport": 1001,
	"./watchListReport/filterReport.js": 1001,
	"./watchListReport/tableReport": 1002,
	"./watchListReport/tableReport.js": 1002,
	"./widgets": 1936,
	"./widgets.js": 1936,
	"./withdrawal": 1937,
	"./withdrawal.js": 1937,
	"./withdrawalReport2": 1938,
	"./withdrawalReport2.js": 1938,
	"./withdrawalRequests": 1939,
	"./withdrawalRequests.js": 1939,
	"./withdrawalRequestsBetShop": 1940,
	"./withdrawalRequestsBetShop.js": 1940,
	"./withdrawalRequestsComissions": 1941,
	"./withdrawalRequestsComissions.js": 1941,
	"./withdrawalRequestsForBetShop": 1942,
	"./withdrawalRequestsForBetShop.js": 1942,
	"./withdrawalRequestsForBetShop2": 1943,
	"./withdrawalRequestsForBetShop2.js": 1943,
	"./withdrawalRequestsRetail": 1944,
	"./withdrawalRequestsRetail.js": 1944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1954;